// Mock data for the ExamOkay system

// 擴展的多語言支持 - 4種語言
export const translations = {
  zh_tw: {
    // 基本導航
    dashboard: '控制台',
    myCourses: '我的課程',
    browseCourses: '瀏覽課程',
    examCenter: '考試中心',
    transactions: '交易記錄',
    profile: '個人資料',
    students: '學生管理',
    analytics: '數據分析',
    settings: '系統設置',
    logout: '登出',
    login: '登入',
    
    // 用戶功能
    userProgress: '學習進度',
    userGrades: '成績記錄',
    userPurchases: '購買記錄',
    courseProgress: '課程進度',
    examResults: '考試成績',
    paymentHistory: '付款歷史',
    
    // 詳細功能
    courseDetails: '課程詳情',
    examDetails: '考試詳情',
    studentDetails: '學生詳情',
    lessonPlan: '課程計劃',
    assignments: '作業管理',
    grades: '成績管理',
    reports: '報告中心',
    
    // 統計數據
    totalStudents: '總學生數',
    activeStudents: '活躍學生',
    completedCourses: '完成課程',
    averageScore: '平均分數',
    thisWeek: '本週',
    thisMonth: '本月',
    thisYear: '本年',
    
    // 按鈕和操作
    viewDetails: '查看詳情',
    editDetails: '編輯詳情',
    deleteItem: '刪除項目',
    addNew: '新增',
    save: '保存',
    cancel: '取消',
    submit: '提交',
    download: '下載',
    upload: '上傳',
    
    // 狀態
    active: '活躍',
    inactive: '非活躍',
    pending: '待處理',
    completed: '已完成',
    inProgress: '進行中',
    draft: '草稿',
    
    // 表單標籤
    name: '姓名',
    email: '電子郵件',
    phone: '電話',
    address: '地址',
    birthDate: '出生日期',
    enrollDate: '入學日期',
    course: '課程',
    instructor: '講師',
    duration: '時長',
    price: '價格',
    description: '描述',
    
    // 用戶相關
    username: '用戶名',
    password: '密碼',
    confirmPassword: '確認密碼',
    forgotPassword: '忘記密碼',
    rememberMe: '記住我',
    welcomeBack: '歡迎回來',
    loginSuccess: '登入成功',
    loginFailed: '登入失敗',
    
    // 進度相關
    overallProgress: '整體進度',
    lessonsCompleted: '已完成課程',
    timeSpent: '學習時間',
    nextLesson: '下一課程',
    continue: '繼續學習',
    
    // 購買相關
    purchaseDate: '購買日期',
    amount: '金額',
    paymentMethod: '付款方式',
    status: '狀態',
    invoice: '發票',
    refund: '退款'
  },
  zh_cn: {
    dashboard: '控制台',
    myCourses: '我的课程',
    browseCourses: '浏览课程',
    examCenter: '考试中心',
    transactions: '交易记录',
    profile: '个人资料',
    students: '学生管理',
    analytics: '数据分析',
    settings: '系统设置',
    logout: '登出',
    login: '登录',
    
    userProgress: '学习进度',
    userGrades: '成绩记录',
    userPurchases: '购买记录',
    courseProgress: '课程进度',
    examResults: '考试成绩',
    paymentHistory: '付款历史',
    
    courseDetails: '课程详情',
    examDetails: '考试详情',
    studentDetails: '学生详情',
    lessonPlan: '课程计划',
    assignments: '作业管理',
    grades: '成绩管理',
    reports: '报告中心',
    
    totalStudents: '总学生数',
    activeStudents: '活跃学生',
    completedCourses: '完成课程',
    averageScore: '平均分数',
    thisWeek: '本周',
    thisMonth: '本月',
    thisYear: '本年',
    
    viewDetails: '查看详情',
    editDetails: '编辑详情',
    deleteItem: '删除项目',
    addNew: '新增',
    save: '保存',
    cancel: '取消',
    submit: '提交',
    download: '下载',
    upload: '上传',
    
    active: '活跃',
    inactive: '非活跃',
    pending: '待处理',
    completed: '已完成',
    inProgress: '进行中',
    draft: '草稿',
    
    name: '姓名',
    email: '电子邮件',
    phone: '电话',
    address: '地址',
    birthDate: '出生日期',
    enrollDate: '入学日期',
    course: '课程',
    instructor: '讲师',
    duration: '时长',
    price: '价格',
    description: '描述',
    
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    forgotPassword: '忘记密码',
    rememberMe: '记住我',
    welcomeBack: '欢迎回来',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    
    overallProgress: '整体进度',
    lessonsCompleted: '已完成课程',
    timeSpent: '学习时间',
    nextLesson: '下一课程',
    continue: '继续学习',
    
    purchaseDate: '购买日期',
    amount: '金额',
    paymentMethod: '付款方式',
    status: '状态',
    invoice: '发票',
    refund: '退款'
  },
  en: {
    dashboard: 'Dashboard',
    myCourses: 'My Courses',
    browseCourses: 'Browse Courses',
    examCenter: 'Exam Center',
    transactions: 'Transactions',
    profile: 'Profile',
    students: 'Student Management',
    analytics: 'Analytics',
    settings: 'Settings',
    logout: 'Logout',
    login: 'Login',
    
    userProgress: 'Learning Progress',
    userGrades: 'Grade Records',
    userPurchases: 'Purchase History',
    courseProgress: 'Course Progress',
    examResults: 'Exam Results',
    paymentHistory: 'Payment History',
    
    courseDetails: 'Course Details',
    examDetails: 'Exam Details',
    studentDetails: 'Student Details',
    lessonPlan: 'Lesson Plan',
    assignments: 'Assignments',
    grades: 'Grades',
    reports: 'Reports',
    
    totalStudents: 'Total Students',
    activeStudents: 'Active Students',
    completedCourses: 'Completed Courses',
    averageScore: 'Average Score',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    
    viewDetails: 'View Details',
    editDetails: 'Edit Details',
    deleteItem: 'Delete Item',
    addNew: 'Add New',
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
    download: 'Download',
    upload: 'Upload',
    
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    completed: 'Completed',
    inProgress: 'In Progress',
    draft: 'Draft',
    
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    birthDate: 'Birth Date',
    enrollDate: 'Enroll Date',
    course: 'Course',
    instructor: 'Instructor',
    duration: 'Duration',
    price: 'Price',
    description: 'Description',
    
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password',
    rememberMe: 'Remember Me',
    welcomeBack: 'Welcome Back',
    loginSuccess: 'Login Successful',
    loginFailed: 'Login Failed',
    
    overallProgress: 'Overall Progress',
    lessonsCompleted: 'Lessons Completed',
    timeSpent: 'Time Spent',
    nextLesson: 'Next Lesson',
    continue: 'Continue Learning',
    
    purchaseDate: 'Purchase Date',
    amount: 'Amount',
    paymentMethod: 'Payment Method',
    status: 'Status',
    invoice: 'Invoice',
    refund: 'Refund'
  },
  ja: {
    dashboard: 'ダッシュボード',
    myCourses: 'マイコース',
    browseCourses: 'コース一覧',
    examCenter: '試験センター',
    transactions: '取引履歴',
    profile: 'プロフィール',
    students: '学生管理',
    analytics: 'データ分析',
    settings: '設定',
    logout: 'ログアウト',
    login: 'ログイン',
    
    userProgress: '学習進捗',
    userGrades: '成績記録',
    userPurchases: '購入履歴',
    courseProgress: 'コース進捗',
    examResults: '試験結果',
    paymentHistory: '支払い履歴',
    
    courseDetails: 'コース詳細',
    examDetails: '試験詳細',
    studentDetails: '学生詳細',
    lessonPlan: 'レッスンプラン',
    assignments: '課題管理',
    grades: '成績管理',
    reports: 'レポート',
    
    totalStudents: '総学生数',
    activeStudents: 'アクティブ学生',
    completedCourses: '完了コース',
    averageScore: '平均スコア',
    thisWeek: '今週',
    thisMonth: '今月',
    thisYear: '今年',
    
    viewDetails: '詳細を見る',
    editDetails: '詳細を編集',
    deleteItem: '項目を削除',
    addNew: '新規追加',
    save: '保存',
    cancel: 'キャンセル',
    submit: '送信',
    download: 'ダウンロード',
    upload: 'アップロード',
    
    active: 'アクティブ',
    inactive: '非アクティブ',
    pending: '保留中',
    completed: '完了',
    inProgress: '進行中',
    draft: '下書き',
    
    name: '名前',
    email: 'メール',
    phone: '電話',
    address: '住所',
    birthDate: '生年月日',
    enrollDate: '入学日',
    course: 'コース',
    instructor: '講師',
    duration: '期間',
    price: '価格',
    description: '説明',
    
    username: 'ユーザー名',
    password: 'パスワード',
    confirmPassword: 'パスワード確認',
    forgotPassword: 'パスワードを忘れた',
    rememberMe: 'ログイン状態を保持',
    welcomeBack: 'おかえりなさい',
    loginSuccess: 'ログイン成功',
    loginFailed: 'ログイン失敗',
    
    overallProgress: '全体の進捗',
    lessonsCompleted: '完了レッスン',
    timeSpent: '学習時間',
    nextLesson: '次のレッスン',
    continue: '学習を続ける',
    
    purchaseDate: '購入日',
    amount: '金額',
    paymentMethod: '支払い方法',
    status: 'ステータス',
    invoice: '請求書',
    refund: '返金'
  }
};

// 用戶進度數據
export const userProgressData = [
  {
    courseId: 1,
    courseName: '中文語文基礎',
    courseNameEn: 'Chinese Language Basics',
    courseNameCn: '中文语文基础',
    courseNameJa: '中国語基礎',
    totalLessons: 59,
    completedLessons: 44,
    progress: 75,
    timeSpent: '32小時',
    lastAccessed: '2025-01-20',
    nextLesson: '寫作技巧 - 第3課',
    currentChapter: '寫作技巧',
    grade: 'A-',
    score: 87
  },
  {
    courseId: 3,
    courseName: 'React 前端開發',
    courseNameEn: 'React Frontend Development',
    courseNameCn: 'React 前端开发',
    courseNameJa: 'React フロントエンド開発',
    totalLessons: 80,
    completedLessons: 36,
    progress: 45,
    timeSpent: '28小時',
    lastAccessed: '2025-01-19',
    nextLesson: '狀態管理 - 第1課',
    currentChapter: '狀態管理',
    grade: 'B+',
    score: 82
  }
];

// 用戶成績記錄
export const userGradesData = [
  {
    id: 1,
    examId: 1,
    examName: '中文語文認證考試',
    examNameEn: 'Chinese Language Certification',
    examNameCn: '中文语文认证考试',
    examNameJa: '中国語認定試験',
    courseId: 1,
    courseName: '中文語文基礎',
    date: '2025-01-15',
    score: 87,
    maxScore: 100,
    grade: 'A-',
    status: 'passed',
    timeSpent: '120分鐘',
    attempts: 1,
    sections: [
      { name: '聽力理解', score: 22, maxScore: 25, percentage: 88 },
      { name: '閱讀理解', score: 26, maxScore: 30, percentage: 87 },
      { name: '語言運用', score: 21, maxScore: 25, percentage: 84 },
      { name: '寫作表達', score: 18, maxScore: 20, percentage: 90 }
    ]
  },
  {
    id: 2,
    examId: 3,
    examName: '微積分期末考',
    examNameEn: 'Calculus Final Exam',
    examNameCn: '微积分期末考',
    examNameJa: '微積分期末試験',
    courseId: 7,
    courseName: '微積分入門',
    date: '2025-01-10',
    score: 92,
    maxScore: 100,
    grade: 'A',
    status: 'passed',
    timeSpent: '150分鐘',
    attempts: 1,
    sections: [
      { name: '選擇題', score: 38, maxScore: 40, percentage: 95 },
      { name: '計算題', score: 32, maxScore: 35, percentage: 91 },
      { name: '證明題', score: 18, maxScore: 20, percentage: 90 },
      { name: '應用題', score: 4, maxScore: 5, percentage: 80 }
    ]
  }
];

// 用戶購買記錄
export const userPurchasesData = [
  {
    id: 1,
    type: 'course',
    itemId: 1,
    itemName: '中文語文基礎',
    itemNameEn: 'Chinese Language Basics',
    itemNameCn: '中文语文基础',
    itemNameJa: '中国語基礎',
    purchaseDate: '2025-01-01',
    amount: 299,
    originalAmount: 399,
    discount: 100,
    discountType: '新年優惠',
    paymentMethod: '信用卡',
    paymentDetails: '**** **** **** 1234',
    status: 'completed',
    invoiceNumber: 'INV-2025-001',
    refundable: true,
    refundDeadline: '2025-02-01',
    accessGranted: true,
    downloadable: true
  },
  {
    id: 2,
    type: 'course',
    itemId: 3,
    itemName: 'React 前端開發',
    itemNameEn: 'React Frontend Development',
    itemNameCn: 'React 前端开发',
    itemNameJa: 'React フロントエンド開発',
    purchaseDate: '2025-01-05',
    amount: 799,
    originalAmount: 999,
    discount: 200,
    discountType: '早鳥優惠',
    paymentMethod: 'PayPal',
    paymentDetails: 'user@email.com',
    status: 'completed',
    invoiceNumber: 'INV-2025-002',
    refundable: true,
    refundDeadline: '2025-02-05',
    accessGranted: true,
    downloadable: true
  },
  {
    id: 3,
    type: 'exam',
    itemId: 1,
    itemName: '中文語文認證考試',
    itemNameEn: 'Chinese Language Certification',
    itemNameCn: '中文语文认证考试',
    itemNameJa: '中国語認定試験',
    purchaseDate: '2025-01-10',
    amount: 150,
    originalAmount: 150,
    discount: 0,
    discountType: null,
    paymentMethod: '信用卡',
    paymentDetails: '**** **** **** 1234',
    status: 'completed',
    invoiceNumber: 'INV-2025-003',
    refundable: false,
    refundDeadline: null,
    accessGranted: true,
    examDate: '2025-01-15',
    examCompleted: true
  }
];

// 原有的課程數據（保持不變）
export const mockCourses = [
  {
    id: 1, 
    name: '中文語文基礎', 
    nameEn: 'Chinese Language Basics', 
    nameCn: '中文语文基础',
    nameJa: '中国語基礎',
    category: 'chinese',
    price: 299, originalPrice: 399, duration: '40小時', level: '初級',
    instructor: '李明華', instructorEn: 'Li Minghua', instructorAvatar: '👨‍🏫',
    purchased: true, progress: 75, rating: 4.8, students: 1250, image: '📚',
    description: '深入學習中文語法、詞彙和寫作技巧，為進階學習奠定堅實基礎。',
    descriptionEn: 'Learn Chinese grammar, vocabulary and writing skills for advanced studies.',
    descriptionCn: '深入学习中文语法、词汇和写作技巧，为进阶学习奠定坚实基础。',
    descriptionJa: '中国語の文法、語彙、ライティングスキルを深く学び、上級学習の堅実な基礎を築きます。',
    chapters: [
      { id: 1, title: '基礎語法', duration: '8小時', completed: true, lessons: 12 },
      { id: 2, title: '詞彙擴展', duration: '10小時', completed: true, lessons: 15 },
      { id: 3, title: '閱讀理解', duration: '12小時', completed: false, lessons: 18 },
      { id: 4, title: '寫作技巧', duration: '10小時', completed: false, lessons: 14 }
    ],
    features: ['HD視頻課程', '互動練習', '專家指導', '證書認證'],
    prerequisites: ['無特殊要求'],
    tags: ['語文', '基礎', '認證'],
    lastUpdated: '2025-06-01',
    language: 'zh',
    difficulty: 1,
    totalLessons: 59,
    totalQuizzes: 15,
    completionRate: 89,
    instructorRating: 4.9,
    reviewCount: 324
  },
  {
    id: 2, 
    name: '古典文學賞析', 
    nameEn: 'Classical Literature Analysis', 
    nameCn: '古典文学赏析',
    nameJa: '古典文学鑑賞',
    category: 'chinese',
    price: 399, originalPrice: 499, duration: '35小時', level: '中級',
    instructor: '王雅琳', instructorEn: 'Wang Yalin', instructorAvatar: '👩‍🏫',
    purchased: false, progress: 0, rating: 4.9, students: 892, image: '📜',
    description: '探索中國古典文學的深度與美，培養文學鑑賞能力。',
    descriptionEn: 'Explore the depth and beauty of Chinese classical literature.',
    descriptionCn: '探索中国古典文学的深度与美，培养文学鉴赏能力。',
    descriptionJa: '中国古典文学の深さと美しさを探求し、文学鑑賞能力を養います。',
    chapters: [
      { id: 1, title: '詩經導讀', duration: '8小時', completed: false, lessons: 10 },
      { id: 2, title: '唐詩宋詞', duration: '12小時', completed: false, lessons: 16 },
      { id: 3, title: '古典小說', duration: '10小時', completed: false, lessons: 12 },
      { id: 4, title: '文學評論', duration: '5小時', completed: false, lessons: 8 }
    ],
    features: ['名師授課', '文本分析', '寫作指導', '討論論壇'],
    prerequisites: ['中文基礎'],
    tags: ['文學', '古典', '賞析'],
    lastUpdated: '2025-05-28',
    language: 'zh',
    difficulty: 2,
    totalLessons: 46,
    totalQuizzes: 12,
    completionRate: 85,
    instructorRating: 4.8,
    reviewCount: 156
  },
  {
    id: 3, 
    name: 'React 前端開發', 
    nameEn: 'React Frontend Development', 
    nameCn: 'React 前端开发',
    nameJa: 'React フロントエンド開発',
    category: 'programming',
    price: 799, originalPrice: 999, duration: '60小時', level: '中級',
    instructor: 'David Chen', instructorEn: 'David Chen', instructorAvatar: '👨‍💻',
    purchased: true, progress: 45, rating: 4.9, students: 2341, image: '⚛️',
    description: '從零開始學習React，掌握現代前端開發技術。',
    descriptionEn: 'Learn React from scratch and master modern frontend development.',
    descriptionCn: '从零开始学习React，掌握现代前端开发技术。',
    descriptionJa: 'Reactをゼロから学び、モダンなフロントエンド開発技術をマスターします。',
    chapters: [
      { id: 1, title: 'React基礎', duration: '15小時', completed: true, lessons: 20 },
      { id: 2, title: 'Hooks深入', duration: '12小時', completed: true, lessons: 16 },
      { id: 3, title: '狀態管理', duration: '18小時', completed: false, lessons: 24 },
      { id: 4, title: '專案實戰', duration: '15小時', completed: false, lessons: 20 }
    ],
    features: ['實戰項目', '代碼審查', '就業指導', '終身更新'],
    prerequisites: ['JavaScript基礎', 'HTML/CSS'],
    tags: ['前端', 'React', 'JavaScript'],
    lastUpdated: '2025-06-15',
    language: 'zh',
    difficulty: 2,
    totalLessons: 80,
    totalQuizzes: 20,
    completionRate: 78,
    instructorRating: 4.9,
    reviewCount: 567
  },
  // 新增英語課程
  {
    id: 4, 
    name: '英語會話實戰', 
    nameEn: 'English Conversation Practice', 
    nameCn: '英语会话实战',
    nameJa: '英会話実戦',
    category: 'english',
    price: 599, originalPrice: 799, duration: '50小時', level: '中級',
    instructor: 'Sarah Johnson', instructorEn: 'Sarah Johnson', instructorAvatar: '👩‍🏫',
    purchased: false, progress: 0, rating: 4.7, students: 1856, image: '🗣️',
    description: '提升英語口語表達能力，掌握日常對話技巧。',
    descriptionEn: 'Improve English speaking skills and master daily conversation techniques.',
    descriptionCn: '提升英语口语表达能力，掌握日常对话技巧。',
    descriptionJa: '英語のスピーキング能力を向上させ、日常会話のテクニックをマスターします。',
    chapters: [
      { id: 1, title: 'Daily Conversations', duration: '12小時', completed: false, lessons: 16 },
      { id: 2, title: 'Business English', duration: '15小時', completed: false, lessons: 20 },
      { id: 3, title: 'Pronunciation', duration: '10小時', completed: false, lessons: 14 },
      { id: 4, title: 'Advanced Topics', duration: '13小時', completed: false, lessons: 18 }
    ],
    features: ['真人對話練習', '發音糾正', '情境模擬', '口語評測'],
    prerequisites: ['英語基礎'],
    tags: ['英語', '口語', '對話'],
    lastUpdated: '2025-06-10',
    language: 'en',
    difficulty: 2,
    totalLessons: 68,
    totalQuizzes: 18,
    completionRate: 82,
    instructorRating: 4.8,
    reviewCount: 423
  },
  
  // 數學課程
  {
    id: 5, 
    name: '微積分入門', 
    nameEn: 'Introduction to Calculus', 
    nameCn: '微积分入门',
    nameJa: '微積分入門',
    category: 'mathematics',
    price: 499, originalPrice: 699, duration: '45小時', level: '初級',
    instructor: '陳教授', instructorEn: 'Professor Chen', instructorAvatar: '👨‍🔬',
    purchased: true, progress: 30, rating: 4.6, students: 987, image: '📐',
    description: '從基礎開始學習微積分，建立扎實的數學基礎。',
    descriptionEn: 'Learn calculus from basics and build solid mathematical foundation.',
    descriptionCn: '从基础开始学习微积分，建立扎实的数学基础。',
    descriptionJa: '基礎から微積分を学び、堅固な数学の基礎を築きます。',
    chapters: [
      { id: 1, title: '極限概念', duration: '10小時', completed: true, lessons: 14 },
      { id: 2, title: '導數應用', duration: '12小時', completed: false, lessons: 16 },
      { id: 3, title: '積分技巧', duration: '15小時', completed: false, lessons: 20 },
      { id: 4, title: '應用實例', duration: '8小時', completed: false, lessons: 12 }
    ],
    features: ['視覺化教學', '實例演練', '習題解答', '進度追蹤'],
    prerequisites: ['高中數學'],
    tags: ['數學', '微積分', '理工'],
    lastUpdated: '2025-05-20',
    language: 'zh',
    difficulty: 2,
    totalLessons: 62,
    totalQuizzes: 16,
    completionRate: 75,
    instructorRating: 4.7,
    reviewCount: 298
  },

  // 程式設計課程
  {
    id: 6, 
    name: 'Python 機器學習', 
    nameEn: 'Python Machine Learning', 
    nameCn: 'Python 机器学习',
    nameJa: 'Python 機械学習',
    category: 'programming',
    price: 899, originalPrice: 1199, duration: '80小時', level: '高級',
    instructor: 'Dr. Wang', instructorEn: 'Dr. Wang', instructorAvatar: '👨‍💻',
    purchased: false, progress: 0, rating: 4.9, students: 1534, image: '🤖',
    description: '深入學習機器學習算法和Python實現。',
    descriptionEn: 'Deep dive into machine learning algorithms and Python implementation.',
    descriptionCn: '深入学习机器学习算法和Python实现。',
    descriptionJa: '機械学習アルゴリズムとPython実装を深く学びます。',
    chapters: [
      { id: 1, title: '數據預處理', duration: '20小時', completed: false, lessons: 25 },
      { id: 2, title: '監督學習', duration: '25小時', completed: false, lessons: 30 },
      { id: 3, title: '無監督學習', duration: '20小時', completed: false, lessons: 25 },
      { id: 4, title: '深度學習', duration: '15小時', completed: false, lessons: 20 }
    ],
    features: ['實戰項目', '數據集提供', '模型部署', '就業指導'],
    prerequisites: ['Python基礎', '統計學基礎'],
    tags: ['Python', 'AI', '機器學習'],
    lastUpdated: '2025-06-05',
    language: 'zh',
    difficulty: 3,
    totalLessons: 100,
    totalQuizzes: 25,
    completionRate: 68,
    instructorRating: 4.9,
    reviewCount: 789
  },

  // 商業課程  
  {
    id: 7, 
    name: '數位行銷策略', 
    nameEn: 'Digital Marketing Strategy', 
    nameCn: '数字营销策略',
    nameJa: 'デジタルマーケティング戦略',
    category: 'business',
    price: 699, originalPrice: 899, duration: '40小時', level: '中級',
    instructor: 'Lisa Zhang', instructorEn: 'Lisa Zhang', instructorAvatar: '👩‍💼',
    purchased: true, progress: 60, rating: 4.8, students: 1245, image: '📈',
    description: '掌握現代數位行銷策略和工具應用。',
    descriptionEn: 'Master modern digital marketing strategies and tool applications.',
    descriptionCn: '掌握现代数字营销策略和工具应用。',
    descriptionJa: 'モダンなデジタルマーケティング戦略とツール活用をマスターします。',
    chapters: [
      { id: 1, title: 'SEO優化', duration: '10小時', completed: true, lessons: 12 },
      { id: 2, title: '社群媒體', duration: '12小時', completed: true, lessons: 15 },
      { id: 3, title: '內容行銷', duration: '10小時', completed: false, lessons: 13 },
      { id: 4, title: '數據分析', duration: '8小時', completed: false, lessons: 10 }
    ],
    features: ['案例研究', '工具實操', '策略制定', '效果追蹤'],
    prerequisites: ['基礎行銷概念'],
    tags: ['行銷', '數位', 'SEO'],
    lastUpdated: '2025-06-12',
    language: 'zh',
    difficulty: 2,
    totalLessons: 50,
    totalQuizzes: 12,
    completionRate: 85,
    instructorRating: 4.8,
    reviewCount: 356
  },

  // 設計課程
  {
    id: 8, 
    name: 'UI/UX 設計實戰', 
    nameEn: 'UI/UX Design Practice', 
    nameCn: 'UI/UX 设计实战',
    nameJa: 'UI/UX デザイン実戦',
    category: 'design',
    price: 799, originalPrice: 999, duration: '55小時', level: '中級',
    instructor: 'Alex Chen', instructorEn: 'Alex Chen', instructorAvatar: '🎨',
    purchased: false, progress: 0, rating: 4.7, students: 876, image: '🎨',
    description: '學習用戶界面和用戶體驗設計的完整流程。',
    descriptionEn: 'Learn the complete process of user interface and user experience design.',
    descriptionCn: '学习用户界面和用户体验设计的完整流程。',
    descriptionJa: 'ユーザーインターフェースとユーザーエクスペリエンスデザインの完全なプロセスを学びます。',
    chapters: [
      { id: 1, title: '設計思維', duration: '12小時', completed: false, lessons: 16 },
      { id: 2, title: '原型設計', duration: '15小時', completed: false, lessons: 20 },
      { id: 3, title: '視覺設計', duration: '18小時', completed: false, lessons: 24 },
      { id: 4, title: '可用性測試', duration: '10小時', completed: false, lessons: 14 }
    ],
    features: ['設計工具教學', '項目作品集', '導師指導', '行業案例'],
    prerequisites: ['基礎設計概念'],
    tags: ['設計', 'UI', 'UX'],
    lastUpdated: '2025-05-25',
    language: 'zh',
    difficulty: 2,
    totalLessons: 74,
    totalQuizzes: 15,
    completionRate: 79,
    instructorRating: 4.7,
    reviewCount: 234
  },

  // 日語課程
  {
    id: 9, 
    name: '日語入門', 
    nameEn: 'Japanese for Beginners', 
    nameCn: '日语入门',
    nameJa: '日本語入門',
    category: 'japanese',
    price: 399, originalPrice: 499, duration: '35小時', level: '初級',
    instructor: '田中先生', instructorEn: 'Tanaka Sensei', instructorAvatar: '👨‍🏫',
    purchased: true, progress: 85, rating: 4.9, students: 1678, image: '🇯🇵',
    description: '從零開始學習日語，掌握基礎語法和日常對話。',
    descriptionEn: 'Learn Japanese from scratch, master basic grammar and daily conversation.',
    descriptionCn: '从零开始学习日语，掌握基础语法和日常对话。',
    descriptionJa: 'ゼロから日本語を学び、基礎文法と日常会話をマスターします。',
    chapters: [
      { id: 1, title: 'ひらがな・カタカナ', duration: '8小時', completed: true, lessons: 12 },
      { id: 2, title: '基礎文法', duration: '12小時', completed: true, lessons: 16 },
      { id: 3, title: '日常會話', duration: '10小時', completed: true, lessons: 14 },
      { id: 4, title: '文化介紹', duration: '5小時', completed: false, lessons: 8 }
    ],
    features: ['發音練習', '文字書寫', '文化背景', '實用對話'],
    prerequisites: ['無'],
    tags: ['日語', '入門', '文化'],
    lastUpdated: '2025-06-08',
    language: 'ja',
    difficulty: 1,
    totalLessons: 50,
    totalQuizzes: 12,
    completionRate: 92,
    instructorRating: 4.9,
    reviewCount: 567
  },

  // 韓語課程
  {
    id: 10, 
    name: '韓語基礎', 
    nameEn: 'Korean Basics', 
    nameCn: '韩语基础',
    nameJa: '韓国語基礎',
    category: 'korean',
    price: 449, originalPrice: 599, duration: '40小時', level: '初級',
    instructor: '김선생', instructorEn: 'Kim Teacher', instructorAvatar: '👩‍🏫',
    purchased: false, progress: 0, rating: 4.6, students: 1234, image: '🇰🇷',
    description: '學習韓語基礎，了解韓國文化和日常用語。',
    descriptionEn: 'Learn Korean basics, understand Korean culture and daily expressions.',
    descriptionCn: '学习韩语基础，了解韩国文化和日常用语。',
    descriptionJa: '韓国語の基礎を学び、韓国文化と日常表現を理解します。',
    chapters: [
      { id: 1, title: '한글 기초', duration: '10小時', completed: false, lessons: 14 },
      { id: 2, title: '기본 문법', duration: '12小時', completed: false, lessons: 16 },
      { id: 3, title: '일상 대화', duration: '12小時', completed: false, lessons: 18 },
      { id: 4, title: '문화 이해', duration: '6小時', completed: false, lessons: 10 }
    ],
    features: ['韓文書寫', '發音指導', 'K-POP歌詞', '韓劇對話'],
    prerequisites: ['無'],
    tags: ['韓語', '韓流', '文化'],
    lastUpdated: '2025-05-30',
    language: 'ko',
    difficulty: 1,
    totalLessons: 58,
    totalQuizzes: 14,
    completionRate: 88,
    instructorRating: 4.6,
    reviewCount: 345
  }
];

// 完整的考試數據庫 - 包含多選題和三種考試模式
export const examQuestionBank = [
  {
    id: 1,
    name: 'JavaScript 基礎認證',
    nameEn: 'JavaScript Fundamentals Certification',
    nameCn: 'JavaScript 基础认证',
    nameJa: 'JavaScript 基礎認定',
    course: 'JavaScript 程式設計',
    duration: 90, // 分鐘
    totalQuestions: 30,
    passingScore: 70,
    category: 'programming',
    difficulty: 'intermediate',
    description: '測試JavaScript基礎語法、DOM操作和ES6特性',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 90,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式', 
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 90,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "What is the correct way to declare a variable in JavaScript?",
        questionZh: "JavaScript中聲明變量的正確方式是什麼？",
        options: [
          "var myVariable;",
          "variable myVariable;",
          "v myVariable;",
          "declare myVariable;"
        ],
        optionsZh: [
          "var myVariable;",
          "variable myVariable;", 
          "v myVariable;",
          "declare myVariable;"
        ],
        correctAnswer: 0,
        explanation: "In JavaScript, variables are declared using 'var', 'let', or 'const' keywords.",
        explanationZh: "在JavaScript中，變量使用'var'、'let'或'const'關鍵字聲明。",
        difficulty: "easy",
        topic: "Variables"
      },
      {
        id: 2,
        question: "Which of the following is NOT a JavaScript data type?",
        questionZh: "以下哪個不是JavaScript數據類型？",
        options: [
          "string",
          "boolean", 
          "integer",
          "undefined"
        ],
        optionsZh: [
          "string",
          "boolean",
          "integer", 
          "undefined"
        ],
        correctAnswer: 2,
        explanation: "JavaScript has number type but not specifically 'integer'. It uses 'number' for all numeric values.",
        explanationZh: "JavaScript有number類型但沒有專門的'integer'。它對所有數值都使用'number'。",
        difficulty: "easy",
        topic: "Data Types"
      },
      {
        id: 3,
        question: "What does the '===' operator do in JavaScript?",
        questionZh: "JavaScript中'==='運算符的作用是什麼？",
        options: [
          "Assignment",
          "Loose equality comparison",
          "Strict equality comparison", 
          "Not equal comparison"
        ],
        optionsZh: [
          "賦值",
          "寬鬆相等比較",
          "嚴格相等比較",
          "不等比較"
        ],
        correctAnswer: 2,
        explanation: "The '===' operator performs strict equality comparison, checking both value and type.",
        explanationZh: "'==='運算符執行嚴格相等比較，檢查值和類型。",
        difficulty: "medium",
        topic: "Operators"
      },
      {
        id: 4,
        question: "How do you create a function in JavaScript?",
        questionZh: "如何在JavaScript中創建函數？",
        options: [
          "function = myFunction() {}",
          "function myFunction() {}",
          "create myFunction() {}",
          "def myFunction() {}"
        ],
        optionsZh: [
          "function = myFunction() {}",
          "function myFunction() {}",
          "create myFunction() {}",
          "def myFunction() {}"
        ],
        correctAnswer: 1,
        explanation: "Functions in JavaScript are declared using the 'function' keyword followed by the function name.",
        explanationZh: "JavaScript中的函數使用'function'關鍵字後跟函數名來聲明。",
        difficulty: "easy",
        topic: "Functions"
      },
      {
        id: 5,
        question: "What is the result of 'typeof null' in JavaScript?",
        questionZh: "JavaScript中'typeof null'的結果是什麼？",
        options: [
          "null",
          "undefined",
          "object",
          "number"
        ],
        optionsZh: [
          "null",
          "undefined", 
          "object",
          "number"
        ],
        correctAnswer: 2,
        explanation: "This is a well-known JavaScript quirk. 'typeof null' returns 'object' due to a legacy bug.",
        explanationZh: "這是JavaScript的一個著名怪癖。由於遺留錯誤，'typeof null'返回'object'。",
        difficulty: "medium",
        topic: "Data Types"
      },
      {
        id: 6,
        question: "Which method is used to add an element to the end of an array?",
        questionZh: "哪個方法用於在數組末尾添加元素？",
        options: [
          "append()",
          "add()",
          "push()",
          "insert()"
        ],
        optionsZh: [
          "append()",
          "add()",
          "push()",
          "insert()"
        ],
        correctAnswer: 2,
        explanation: "The push() method adds one or more elements to the end of an array.",
        explanationZh: "push()方法將一個或多個元素添加到數組的末尾。",
        difficulty: "easy",
        topic: "Arrays"
      },
      {
        id: 7,
        question: "What is a closure in JavaScript?",
        questionZh: "JavaScript中的閉包是什麼？",
        options: [
          "A way to close a function",
          "A function that has access to outer scope variables",
          "A method to end a loop",
          "A type of error handling"
        ],
        optionsZh: [
          "關閉函數的方式",
          "可以訪問外部作用域變量的函數",
          "結束循環的方法", 
          "一種錯誤處理類型"
        ],
        correctAnswer: 1,
        explanation: "A closure is a function that has access to variables in its outer (enclosing) scope even after the outer function returns.",
        explanationZh: "閉包是一個函數，即使在外部函數返回後，它仍可以訪問其外部（封閉）作用域中的變量。",
        difficulty: "hard",
        topic: "Advanced Concepts"
      },
      {
        id: 8,
        question: "How do you select an element by ID in JavaScript?",
        questionZh: "如何在JavaScript中按ID選擇元素？",
        options: [
          "document.selectById('id')",
          "document.getElementById('id')",
          "document.findById('id')",
          "document.getElement('id')"
        ],
        optionsZh: [
          "document.selectById('id')",
          "document.getElementById('id')",
          "document.findById('id')",
          "document.getElement('id')"
        ],
        correctAnswer: 1,
        explanation: "document.getElementById() is the standard method to select an element by its ID.",
        explanationZh: "document.getElementById()是按ID選擇元素的標準方法。",
        difficulty: "easy",
        topic: "DOM Manipulation"
      },
      {
        id: 9,
        question: "What is the difference between 'let' and 'var'?",
        questionZh: "'let'和'var'有什麼區別？",
        options: [
          "No difference",
          "let has block scope, var has function scope",
          "var has block scope, let has function scope",
          "let is faster than var"
        ],
        optionsZh: [
          "沒有區別",
          "let有塊作用域，var有函數作用域",
          "var有塊作用域，let有函數作用域",
          "let比var更快"
        ],
        correctAnswer: 1,
        explanation: "'let' has block scope and cannot be redeclared, while 'var' has function scope and can be redeclared.",
        explanationZh: "'let'有塊作用域且不能重複聲明，而'var'有函數作用域且可以重複聲明。",
        difficulty: "medium",
        topic: "Variables"
      },
      {
        id: 10,
        question: "Which of the following is a way to create an object in JavaScript?",
        questionZh: "以下哪個是在JavaScript中創建對象的方式？",
        options: [
          "var obj = {};",
          "var obj = new Object();",
          "var obj = Object.create();",
          "All of the above"
        ],
        optionsZh: [
          "var obj = {};",
          "var obj = new Object();",
          "var obj = Object.create();",
          "以上所有"
        ],
        correctAnswer: 3,
        explanation: "All three methods can be used to create objects in JavaScript.",
        explanationZh: "這三種方法都可以用來在JavaScript中創建對象。",
        difficulty: "medium",
        topic: "Objects"
      },
      {
        id: 11,
        question: "What does the 'this' keyword refer to?",
        questionZh: "'this'關鍵字指的是什麼？",
        options: [
          "The current function",
          "The global object",
          "The object that owns the method",
          "The parent object"
        ],
        optionsZh: [
          "當前函數",
          "全局對象",
          "擁有該方法的對象",
          "父對象"
        ],
        correctAnswer: 2,
        explanation: "'this' refers to the object that owns the method where 'this' is used.",
        explanationZh: "'this'指的是擁有使用'this'的方法的對象。",
        difficulty: "medium",
        topic: "Objects"
      },
      {
        id: 12,
        question: "How do you handle errors in JavaScript?",
        questionZh: "如何在JavaScript中處理錯誤？",
        options: [
          "try...catch",
          "error...handle",
          "catch...error",
          "handle...exception"
        ],
        optionsZh: [
          "try...catch",
          "error...handle",
          "catch...error",
          "handle...exception"
        ],
        correctAnswer: 0,
        explanation: "JavaScript uses try...catch blocks to handle errors and exceptions.",
        explanationZh: "JavaScript使用try...catch塊來處理錯誤和異常。",
        difficulty: "easy",
        topic: "Error Handling"
      },
      {
        id: 13,
        question: "What is the purpose of the 'async' keyword?",
        questionZh: "'async'關鍵字的目的是什麼？",
        options: [
          "To make functions run faster",
          "To make functions return a Promise",
          "To make functions run in parallel",
          "To make functions synchronous"
        ],
        optionsZh: [
          "使函數運行得更快",
          "使函數返回Promise",
          "使函數並行運行",
          "使函數同步"
        ],
        correctAnswer: 1,
        explanation: "The 'async' keyword makes a function return a Promise and allows the use of 'await'.",
        explanationZh: "'async'關鍵字使函數返回Promise並允許使用'await'。",
        difficulty: "hard",
        topic: "Async Programming"
      },
      {
        id: 14,
        question: "Which method is used to remove the last element from an array?",
        questionZh: "哪個方法用於從數組中移除最後一個元素？",
        options: [
          "removeLast()",
          "pop()",
          "delete()",
          "splice()"
        ],
        optionsZh: [
          "removeLast()",
          "pop()",
          "delete()",
          "splice()"
        ],
        correctAnswer: 1,
        explanation: "The pop() method removes and returns the last element of an array.",
        explanationZh: "pop()方法移除並返回數組的最後一個元素。",
        difficulty: "easy",
        topic: "Arrays"
      },
      {
        id: 15,
        question: "What is the result of '2' + 3 in JavaScript?",
        questionZh: "JavaScript中'2' + 3的結果是什麼？",
        options: [
          "5",
          "23",
          "Error",
          "undefined"
        ],
        optionsZh: [
          "5",
          "23",
          "錯誤",
          "undefined"
        ],
        correctAnswer: 1,
        explanation: "JavaScript performs string concatenation when one operand is a string, resulting in '23'.",
        explanationZh: "當一個操作數是字符串時，JavaScript執行字符串連接，結果是'23'。",
        difficulty: "medium",
        topic: "Type Coercion"
      },
      {
        id: 16,
        question: "How do you create a comment in JavaScript?",
        questionZh: "如何在JavaScript中創建註釋？",
        options: [
          "<!-- comment -->",
          "// comment",
          "# comment",
          "/* comment */"
        ],
        optionsZh: [
          "<!-- comment -->",
          "// comment",
          "# comment",
          "/* comment */"
        ],
        correctAnswer: 1,
        explanation: "JavaScript uses // for single-line comments and /* */ for multi-line comments.",
        explanationZh: "JavaScript使用//作為單行註釋，使用/* */作為多行註釋。",
        difficulty: "easy",
        topic: "Syntax"
      },
      {
        id: 17,
        question: "What is the difference between '==' and '==='?",
        questionZh: "'=='和'==='有什麼區別？",
        options: [
          "No difference",
          "== checks type, === doesn't",
          "=== checks type, == doesn't",
          "== is faster"
        ],
        optionsZh: [
          "沒有區別",
          "==檢查類型，===不檢查",
          "===檢查類型，==不檢查",
          "==更快"
        ],
        correctAnswer: 2,
        explanation: "'===' performs strict comparison (value and type), while '==' performs loose comparison with type coercion.",
        explanationZh: "'==='執行嚴格比較（值和類型），而'=='執行帶類型轉換的寬鬆比較。",
        difficulty: "medium",
        topic: "Operators"
      },
      {
        id: 18,
        question: "Which method is used to convert a string to uppercase?",
        questionZh: "哪個方法用於將字符串轉換為大寫？",
        options: [
          "toUpper()",
          "uppercase()",
          "toUpperCase()",
          "upper()"
        ],
        optionsZh: [
          "toUpper()",
          "uppercase()",
          "toUpperCase()",
          "upper()"
        ],
        correctAnswer: 2,
        explanation: "The toUpperCase() method converts a string to uppercase letters.",
        explanationZh: "toUpperCase()方法將字符串轉換為大寫字母。",
        difficulty: "easy",
        topic: "Strings"
      },
      {
        id: 19,
        question: "What is the purpose of the 'return' statement?",
        questionZh: "'return'語句的目的是什麼？",
        options: [
          "To restart a function",
          "To exit a function and optionally return a value",
          "To repeat a function",
          "To call another function"
        ],
        optionsZh: [
          "重新啟動函數",
          "退出函數並可選地返回值",
          "重複函數",
          "調用另一個函數"
        ],
        correctAnswer: 1,
        explanation: "The 'return' statement exits a function and can optionally return a value to the caller.",
        explanationZh: "'return'語句退出函數，並可以可選地向調用者返回值。",
        difficulty: "easy",
        topic: "Functions"
      },
      {
        id: 20,
        question: "How do you access the first element of an array?",
        questionZh: "如何訪問數組的第一個元素？",
        options: [
          "array.first()",
          "array[1]",
          "array[0]",
          "array.get(0)"
        ],
        optionsZh: [
          "array.first()",
          "array[1]",
          "array[0]",
          "array.get(0)"
        ],
        correctAnswer: 2,
        explanation: "Arrays in JavaScript are zero-indexed, so the first element is accessed with array[0].",
        explanationZh: "JavaScript中的數組是零索引的，所以第一個元素用array[0]訪問。",
        difficulty: "easy",
        topic: "Arrays"
      },
      {
        id: 21,
        question: "What is an event listener in JavaScript?",
        questionZh: "JavaScript中的事件監聽器是什麼？",
        options: [
          "A function that listens to audio",
          "A function that responds to events",
          "A function that creates events",
          "A function that prevents events"
        ],
        optionsZh: [
          "監聽音頻的函數",
          "響應事件的函數",
          "創建事件的函數",
          "阻止事件的函數"
        ],
        correctAnswer: 1,
        explanation: "An event listener is a function that waits for and responds to specific events like clicks or key presses.",
        explanationZh: "事件監聽器是等待並響應特定事件（如點擊或按鍵）的函數。",
        difficulty: "medium",
        topic: "Events"
      },
      {
        id: 22,
        question: "What does JSON stand for?",
        questionZh: "JSON代表什麼？",
        options: [
          "JavaScript Object Notation",
          "JavaScript Online Network",
          "Java Standard Object Name",
          "JavaScript Organized Numbers"
        ],
        optionsZh: [
          "JavaScript Object Notation",
          "JavaScript Online Network",
          "Java Standard Object Name",
          "JavaScript Organized Numbers"
        ],
        correctAnswer: 0,
        explanation: "JSON stands for JavaScript Object Notation, a lightweight data interchange format.",
        explanationZh: "JSON代表JavaScript Object Notation，一種輕量級的數據交換格式。",
        difficulty: "easy",
        topic: "Data Formats"
      },
      {
        id: 23,
        question: "Which method is used to parse a JSON string?",
        questionZh: "哪個方法用於解析JSON字符串？",
        options: [
          "JSON.parse()",
          "JSON.decode()",
          "JSON.read()",
          "JSON.convert()"
        ],
        optionsZh: [
          "JSON.parse()",
          "JSON.decode()",
          "JSON.read()",
          "JSON.convert()"
        ],
        correctAnswer: 0,
        explanation: "JSON.parse() is used to parse a JSON string and convert it to a JavaScript object.",
        explanationZh: "JSON.parse()用於解析JSON字符串並將其轉換為JavaScript對象。",
        difficulty: "easy",
        topic: "JSON"
      },
      {
        id: 24,
        question: "What is the scope of a variable declared with 'const'?",
        questionZh: "用'const'聲明的變量的作用域是什麼？",
        options: [
          "Global scope",
          "Function scope",
          "Block scope",
          "Module scope"
        ],
        optionsZh: [
          "全局作用域",
          "函數作用域",
          "塊作用域",
          "模塊作用域"
        ],
        correctAnswer: 2,
        explanation: "Variables declared with 'const' have block scope and cannot be reassigned.",
        explanationZh: "用'const'聲明的變量有塊作用域且不能重新賦值。",
        difficulty: "medium",
        topic: "Variables"
      },
      {
        id: 25,
        question: "How do you check if a variable is an array?",
        questionZh: "如何檢查變量是否為數組？",
        options: [
          "typeof variable === 'array'",
          "Array.isArray(variable)",
          "variable.isArray()",
          "variable instanceof Array"
        ],
        optionsZh: [
          "typeof variable === 'array'",
          "Array.isArray(variable)",
          "variable.isArray()",
          "variable instanceof Array"
        ],
        correctAnswer: 1,
        explanation: "Array.isArray() is the most reliable method to check if a variable is an array.",
        explanationZh: "Array.isArray()是檢查變量是否為數組的最可靠方法。",
        difficulty: "medium",
        topic: "Arrays"
      },
      {
        id: 26,
        question: "What is the difference between 'null' and 'undefined'?",
        questionZh: "'null'和'undefined'有什麼區別？",
        options: [
          "No difference",
          "null is assigned, undefined is not declared",
          "undefined is assigned, null is not declared",
          "null is faster"
        ],
        optionsZh: [
          "沒有區別",
          "null是被賦值的，undefined是未聲明的",
          "undefined是被賦值的，null是未聲明的",
          "null更快"
        ],
        correctAnswer: 1,
        explanation: "'null' is an assigned value representing no value, while 'undefined' means a variable has been declared but not assigned.",
        explanationZh: "'null'是表示無值的賦值，而'undefined'意味著變量已聲明但未賦值。",
        difficulty: "medium",
        topic: "Data Types"
      },
      {
        id: 27,
        question: "Which method adds an element to the beginning of an array?",
        questionZh: "哪個方法在數組開頭添加元素？",
        options: [
          "push()",
          "unshift()",
          "prepend()",
          "addFirst()"
        ],
        optionsZh: [
          "push()",
          "unshift()",
          "prepend()",
          "addFirst()"
        ],
        correctAnswer: 1,
        explanation: "The unshift() method adds one or more elements to the beginning of an array.",
        explanationZh: "unshift()方法在數組開頭添加一個或多個元素。",
        difficulty: "easy",
        topic: "Arrays"
      },
      {
        id: 28,
        question: "What is a callback function?",
        questionZh: "什麼是回調函數？",
        options: [
          "A function that calls back to the server",
          "A function passed as an argument to another function",
          "A function that returns to previous state",
          "A function that calls itself"
        ],
        optionsZh: [
          "回調到服務器的函數",
          "作為參數傳遞給另一個函數的函數",
          "返回到先前狀態的函數",
          "調用自身的函數"
        ],
        correctAnswer: 1,
        explanation: "A callback function is a function passed as an argument to another function and executed later.",
        explanationZh: "回調函數是作為參數傳遞給另一個函數並稍後執行的函數。",
        difficulty: "medium",
        topic: "Functions"
      },
      {
        id: 29,
        question: "How do you create a loop that runs 5 times?",
        questionZh: "如何創建運行5次的循環？",
        options: [
          "for(i=0; i<5; i++)",
          "for(i=1; i<=5; i++)",
          "for(i=0; i<=5; i++)",
          "Both A and B"
        ],
        optionsZh: [
          "for(i=0; i<5; i++)",
          "for(i=1; i<=5; i++)",
          "for(i=0; i<=5; i++)",
          "A和B都可以"
        ],
        correctAnswer: 3,
        explanation: "Both 'for(i=0; i<5; i++)' and 'for(i=1; i<=5; i++)' will run exactly 5 times.",
        explanationZh: "'for(i=0; i<5; i++)'和'for(i=1; i<=5; i++)'都會運行正好5次。",
        difficulty: "easy",
        topic: "Loops"
      },
      {
        id: 30,
        question: "What is the purpose of 'use strict' in JavaScript?",
        questionZh: "JavaScript中'use strict'的目的是什麼？",
        options: [
          "To make code run faster",
          "To enable strict mode for better error checking",
          "To use the latest JavaScript features",
          "To compress the code"
        ],
        optionsZh: [
          "使代碼運行更快",
          "啟用嚴格模式以進行更好的錯誤檢查",
          "使用最新的JavaScript功能",
          "壓縮代碼"
        ],
        correctAnswer: 1,
        explanation: "'use strict' enables strict mode, which catches common coding errors and prevents unsafe actions.",
        explanationZh: "'use strict'啟用嚴格模式，捕獲常見的編碼錯誤並防止不安全的操作。",
        difficulty: "medium",
        topic: "Best Practices"
      }
    ]
  },
  {
    id: 2,
    name: 'HTML/CSS 網頁設計',
    nameEn: 'HTML/CSS Web Design',
    nameCn: 'HTML/CSS 网页设计',
    nameJa: 'HTML/CSS ウェブデザイン',
    course: '網頁設計基礎',
    duration: 75,
    totalQuestions: 30,
    passingScore: 70,
    category: 'design',
    difficulty: 'beginner',
    description: '測試HTML標籤、CSS樣式和響應式設計知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 75,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 75,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      // 30 HTML/CSS questions would go here - abbreviated for space
      {
        id: 1,
        question: "What does HTML stand for?",
        questionZh: "HTML代表什麼？",
        options: [
          "HyperText Markup Language",
          "High Tech Modern Language",
          "Home Tool Markup Language",
          "Hyperlink and Text Markup Language"
        ],
        optionsZh: [
          "HyperText Markup Language",
          "High Tech Modern Language", 
          "Home Tool Markup Language",
          "Hyperlink and Text Markup Language"
        ],
        correctAnswer: 0,
        explanation: "HTML stands for HyperText Markup Language, the standard markup language for creating web pages.",
        explanationZh: "HTML代表HyperText Markup Language，是創建網頁的標準標記語言。",
        difficulty: "easy",
        topic: "HTML Basics"
      }
      // ... 29 more questions
    ]
  },
  {
    id: 3,
    name: 'Python 程式設計',
    nameEn: 'Python Programming',
    nameCn: 'Python 程序设计',
    nameJa: 'Python プログラミング',
    course: 'Python 基礎',
    duration: 90,
    totalQuestions: 30,
    passingScore: 70,
    category: 'programming',
    difficulty: 'intermediate',
    description: '測試Python語法、數據結構和面向對象編程',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 90,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 90,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "How do you create a comment in Python?",
        questionZh: "如何在Python中創建註釋？",
        options: [
          "// comment",
          "# comment",
          "/* comment */",
          "-- comment"
        ],
        optionsZh: [
          "// comment",
          "# comment",
          "/* comment */",
          "-- comment"
        ],
        correctAnswer: 1,
        explanation: "Python uses # for single-line comments and triple quotes for multi-line comments.",
        explanationZh: "Python使用#作為單行註釋，使用三重引號作為多行註釋。",
        difficulty: "easy",
        topic: "Syntax"
      }
      // ... 29 more questions
    ]
  },
  {
    id: 4,
    name: '數據庫管理 SQL',
    nameEn: 'Database Management SQL',
    nameCn: '数据库管理 SQL',
    nameJa: 'データベース管理 SQL',
    course: '數據庫基礎',
    duration: 80,
    totalQuestions: 30,
    passingScore: 70,
    category: 'database',
    difficulty: 'intermediate',
    description: '測試SQL查詢、數據庫設計和關係型數據庫概念',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 80,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 80,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "Which SQL statement is used to extract data from a database?",
        questionZh: "哪個SQL語句用於從數據庫中提取數據？",
        options: [
          "EXTRACT",
          "SELECT",
          "GET",
          "FETCH"
        ],
        optionsZh: [
          "EXTRACT",
          "SELECT",
          "GET",
          "FETCH"
        ],
        correctAnswer: 1,
        explanation: "The SELECT statement is used to query and retrieve data from a database.",
        explanationZh: "SELECT語句用於查詢和從數據庫中檢索數據。",
        difficulty: "easy",
        topic: "SQL Basics"
      }
      // ... 29 more questions
    ]
  },
  {
    id: 5,
    name: '網路安全基礎',
    nameEn: 'Cybersecurity Fundamentals',
    nameCn: '网络安全基础',
    nameJa: 'サイバーセキュリティ基礎',
    course: '資訊安全',
    duration: 85,
    totalQuestions: 30,
    passingScore: 75,
    category: 'security',
    difficulty: 'advanced',
    description: '測試網路安全威脅、防護措施和安全協議知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 85,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 85,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "What does SSL stand for?",
        questionZh: "SSL代表什麼？",
        options: [
          "Secure Socket Layer",
          "System Security Level",
          "Safe Server Link",
          "Secure Software License"
        ],
        optionsZh: [
          "Secure Socket Layer",
          "System Security Level",
          "Safe Server Link",
          "Secure Software License"
        ],
        correctAnswer: 0,
        explanation: "SSL stands for Secure Socket Layer, a protocol for establishing encrypted links between servers and clients.",
        explanationZh: "SSL代表Secure Socket Layer，是在服務器和客戶端之間建立加密鏈接的協議。",
        difficulty: "easy",
        topic: "Encryption"
      }
      // ... 29 more questions
    ]
  },
  
  // HKDSE 香港中學文憑考試
  {
    id: 6,
    name: 'HKDSE 中國語文',
    nameEn: 'HKDSE Chinese Language',
    nameCn: 'HKDSE 中国语文',
    nameJa: 'HKDSE 中国語',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: '測試中文閱讀理解、語文運用和文學知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "以下哪個詞語的讀音是正確的？",
        questionEn: "Which of the following pronunciations is correct?",
        audioUrl: "/audio/chinese/pronunciation_1.mp3",
        options: [
          "「間」讀作 jiān（平聲）",
          "「間」讀作 jiàn（去聲）",
          "「間」在「時間」中讀作 jiān（平聲）",
          "「間」在「間隔」中讀作 jiàn（去聲）"
        ],
        correctAnswer: 2,
        explanation: "「間」字在「時間」一詞中讀作 jiān（平聲），在「間隔」中讀作 jiàn（去聲）。",
        explanationEn: "The character '間' is pronounced as jiān (first tone) in '時間' and jiàn (fourth tone) in '間隔'.",
        difficulty: "medium",
        topic: "語音知識",
        hasAudio: true
      },
      {
        id: 2,
        question: "下列句子中，哪一句使用了比喻修辭手法？",
        questionEn: "Which sentence uses metaphor as a rhetorical device?",
        options: [
          "春風吹綠了大地",
          "她的心如刀割一般疼痛",
          "雨點打在窗戶上",
          "鳥兒在樹上歌唱"
        ],
        correctAnswer: 1,
        explanation: "「她的心如刀割一般疼痛」使用了明喻，將心痛比作刀割，是比喻修辭手法。",
        explanationEn: "The sentence uses simile, comparing heartache to being cut by a knife, which is a metaphorical device.",
        difficulty: "easy",
        topic: "修辭手法"
      },
      {
        id: 3,
        question: "閱讀以下詩句：「春眠不覺曉，處處聞啼鳥。夜來風雨聲，花落知多少。」這首詩的作者是誰？",
        questionEn: "Read the following poem: '春眠不覺曉，處處聞啼鳥。夜來風雨聲，花落知多少。' Who is the author?",
        audioUrl: "/audio/chinese/poem_1.mp3",
        options: [
          "李白",
          "杜甫", 
          "孟浩然",
          "王維"
        ],
        correctAnswer: 2,
        explanation: "這是孟浩然的《春曉》，是唐詩中著名的田園詩作品。",
        explanationEn: "This is 'Spring Dawn' (春曉) by Meng Haoran, a famous pastoral poem from the Tang Dynasty.",
        difficulty: "medium",
        topic: "古典文學",
        hasAudio: true
      }
      // ... 更多中文題目
    ]
  },
  
  {
    id: 7,
    name: 'HKDSE English Language',
    nameEn: 'HKDSE English Language',
    nameCn: 'HKDSE 英语',
    nameJa: 'HKDSE 英語',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'language',
    difficulty: 'advanced',
    description: 'Test English reading comprehension, grammar, and vocabulary',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "Listen to the audio and choose the correct answer: What is the main topic of the conversation?",
        questionZh: "聽音頻並選擇正確答案：對話的主要話題是什麼？",
        audioUrl: "/audio/english/listening_1.mp3",
        options: [
          "Planning a vacation",
          "Discussing work schedules", 
          "Talking about hobbies",
          "Arranging a meeting"
        ],
        optionsZh: [
          "計劃假期",
          "討論工作時間表",
          "談論興趣愛好", 
          "安排會議"
        ],
        correctAnswer: 0,
        explanation: "The conversation is about planning a summer vacation to Europe.",
        explanationZh: "對話內容是關於計劃去歐洲的夏季假期。",
        difficulty: "medium",
        topic: "Listening Comprehension",
        hasAudio: true
      },
      {
        id: 2,
        question: "Choose the correct form: 'If I _____ you, I would accept the offer.'",
        questionZh: "選擇正確形式：'If I _____ you, I would accept the offer.'",
        options: [
          "am",
          "was",
          "were", 
          "will be"
        ],
        correctAnswer: 2,
        explanation: "In hypothetical conditional sentences, we use 'were' for all persons after 'if'.",
        explanationZh: "在假設性條件句中，'if'後面所有人稱都使用'were'。",
        difficulty: "medium",
        topic: "Grammar"
      }
      // ... 更多英文題目
    ]
  },
  
  {
    id: 8,
    name: 'HKDSE Mathematics',
    nameEn: 'HKDSE Mathematics',
    nameCn: 'HKDSE 数学',
    nameJa: 'HKDSE 数学',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試代數、幾何、統計和概率知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "Solve for x: $2x^2 + 5x - 3 = 0$",
        questionZh: "求解 x：$2x^2 + 5x - 3 = 0$",
        mathExpression: "2x^2 + 5x - 3 = 0",
        options: [
          "$x = \\frac{1}{2}, x = -3$",
          "$x = \\frac{-1}{2}, x = 3$",
          "$x = \\frac{1}{2}, x = 3$",
          "$x = \\frac{-1}{2}, x = -3$"
        ],
        optionsZh: [
          "$x = \\frac{1}{2}, x = -3$",
          "$x = \\frac{-1}{2}, x = 3$", 
          "$x = \\frac{1}{2}, x = 3$",
          "$x = \\frac{-1}{2}, x = -3$"
        ],
        correctAnswer: 0,
        explanation: "Using the quadratic formula: $x = \\frac{-5 \\pm \\sqrt{25 + 24}}{4} = \\frac{-5 \\pm 7}{4}$, so $x = \\frac{1}{2}$ or $x = -3$",
        explanationZh: "使用二次公式：$x = \\frac{-5 \\pm \\sqrt{25 + 24}}{4} = \\frac{-5 \\pm 7}{4}$，所以 $x = \\frac{1}{2}$ 或 $x = -3$",
        difficulty: "medium",
        topic: "Quadratic Equations",
        hasMath: true
      },
      {
        id: 2,
        question: "Find the area of a circle with radius $r = 5$ cm. Use $\\pi = 3.14159$",
        questionZh: "求半徑 $r = 5$ cm 的圓的面積。使用 $\\pi = 3.14159$",
        mathExpression: "A = \\pi r^2",
        svgDiagram: `
          <svg width="200" height="200" viewBox="0 0 200 200">
            <circle cx="100" cy="100" r="80" fill="none" stroke="#3b82f6" stroke-width="2"/>
            <line x1="100" y1="100" x2="180" y2="100" stroke="#ef4444" stroke-width="2"/>
            <text x="140" y="95" fill="#ef4444" font-size="14">r = 5</text>
            <circle cx="100" cy="100" r="3" fill="#3b82f6"/>
          </svg>
        `,
        options: [
          "$78.54 \\text{ cm}^2$",
          "$31.42 \\text{ cm}^2$", 
          "$15.71 \\text{ cm}^2$",
          "$157.08 \\text{ cm}^2$"
        ],
        correctAnswer: 0,
        explanation: "Area = $\\pi r^2 = 3.14159 \\times 5^2 = 3.14159 \\times 25 = 78.54 \\text{ cm}^2$",
        explanationZh: "面積 = $\\pi r^2 = 3.14159 \\times 5^2 = 3.14159 \\times 25 = 78.54 \\text{ cm}^2$",
        difficulty: "easy",
        topic: "Geometry",
        hasMath: true,
        hasSvg: true
      }
      // ... 更多數學題目
    ]
  },
  
  {
    id: 9,
    name: 'HKDSE Physics',
    nameEn: 'HKDSE Physics',
    nameCn: 'HKDSE 物理',
    nameJa: 'HKDSE 物理学',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'science',
    difficulty: 'advanced',
    description: '測試力學、電磁學、熱學和現代物理知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 150,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 150,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "A ball is thrown vertically upward with initial velocity $v_0 = 20 \\text{ m/s}$. What is the maximum height reached? (Use $g = 10 \\text{ m/s}^2$)",
        questionZh: "一球以初速度 $v_0 = 20 \\text{ m/s}$ 垂直向上拋出。最大高度是多少？（使用 $g = 10 \\text{ m/s}^2$）",
        mathExpression: "v^2 = v_0^2 - 2gh",
        svgDiagram: `
          <svg width="250" height="300" viewBox="0 0 250 300">
            <defs>
              <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
                <polygon points="0 0, 10 3.5, 0 7" fill="#ef4444" />
              </marker>
            </defs>
            <!-- Ground -->
            <line x1="50" y1="280" x2="200" y2="280" stroke="#8b5cf6" stroke-width="3"/>
            <!-- Trajectory -->
            <path d="M 125 280 Q 125 150 125 100" fill="none" stroke="#3b82f6" stroke-width="2" stroke-dasharray="5,5"/>
            <!-- Ball at different positions -->
            <circle cx="125" cy="280" r="8" fill="#ef4444"/>
            <circle cx="125" cy="200" r="6" fill="#ef4444" opacity="0.6"/>
            <circle cx="125" cy="120" r="4" fill="#ef4444" opacity="0.4"/>
            <circle cx="125" cy="100" r="4" fill="#ef4444" opacity="0.8"/>
            <!-- Initial velocity arrow -->
            <line x1="125" y1="280" x2="125" y2="220" stroke="#ef4444" stroke-width="3" marker-end="url(#arrowhead)"/>
            <text x="130" y="250" fill="#ef4444" font-size="12">v₀ = 20 m/s</text>
            <!-- Height indicator -->
            <line x1="160" y1="280" x2="160" y2="100" stroke="#10b981" stroke-width="2"/>
            <text x="165" y="190" fill="#10b981" font-size="12">h = ?</text>
            <!-- Labels -->
            <text x="80" y="295" fill="#8b5cf6" font-size="12">Ground</text>
            <text x="80" y="110" fill="#3b82f6" font-size="12">Max Height</text>
          </svg>
        `,
        options: [
          "$20 \\text{ m}$",
          "$15 \\text{ m}$",
          "$25 \\text{ m}$",
          "$10 \\text{ m}$"
        ],
        correctAnswer: 0,
        explanation: "At maximum height, $v = 0$. Using $v^2 = v_0^2 - 2gh$: $0 = 20^2 - 2(10)h$, so $h = \\frac{400}{20} = 20 \\text{ m}$",
        explanationZh: "在最大高度時，$v = 0$。使用 $v^2 = v_0^2 - 2gh$：$0 = 20^2 - 2(10)h$，所以 $h = \\frac{400}{20} = 20 \\text{ m}$",
        difficulty: "medium",
        topic: "Kinematics",
        hasMath: true,
        hasSvg: true
      }
      // ... 更多物理題目
    ]
  },
  
  {
    id: 10,
    name: 'HKDSE Chemistry',
    nameEn: 'HKDSE Chemistry',
    nameCn: 'HKDSE 化学',
    nameJa: 'HKDSE 化学',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'science',
    difficulty: 'advanced',
    description: '測試無機化學、有機化學和物理化學知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 150,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 150,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "What is the molecular formula of glucose?",
        questionZh: "葡萄糖的分子式是什麼？",
        svgDiagram: `
          <svg width="300" height="200" viewBox="0 0 300 200">
            <!-- Glucose structure -->
            <g transform="translate(50,50)">
              <!-- Ring structure -->
              <polygon points="50,20 100,50 100,100 50,130 0,100 0,50" fill="none" stroke="#3b82f6" stroke-width="2"/>
              <!-- Carbon atoms -->
              <circle cx="50" cy="20" r="8" fill="#666"/>
              <circle cx="100" cy="50" r="8" fill="#666"/>
              <circle cx="100" cy="100" r="8" fill="#666"/>
              <circle cx="50" cy="130" r="8" fill="#666"/>
              <circle cx="0" cy="100" r="8" fill="#666"/>
              <circle cx="0" cy="50" r="8" fill="#ef4444"/>
              <!-- OH groups -->
              <text x="45" y="10" font-size="12" fill="#ef4444">OH</text>
              <text x="110" y="55" font-size="12" fill="#ef4444">OH</text>
              <text x="110" y="105" font-size="12" fill="#ef4444">OH</text>
              <text x="45" y="145" font-size="12" fill="#ef4444">OH</text>
              <text x="-15" y="105" font-size="12" fill="#ef4444">OH</text>
              <!-- CH2OH group -->
              <line x1="0" y1="50" x2="-30" y2="30" stroke="#666" stroke-width="2"/>
              <text x="-60" y="25" font-size="12" fill="#666">CH₂OH</text>
              <!-- Labels -->
              <text x="120" y="75" font-size="14" fill="#3b82f6">Glucose</text>
            </g>
          </svg>
        `,
        options: [
          "$\\text{C}_6\\text{H}_{12}\\text{O}_6$",
          "$\\text{C}_6\\text{H}_{10}\\text{O}_5$",
          "$\\text{C}_5\\text{H}_{10}\\text{O}_5$",
          "$\\text{C}_6\\text{H}_{14}\\text{O}_6$"
        ],
        correctAnswer: 0,
        explanation: "Glucose is a hexose sugar with molecular formula $\\text{C}_6\\text{H}_{12}\\text{O}_6$",
        explanationZh: "葡萄糖是己糖，分子式為 $\\text{C}_6\\text{H}_{12}\\text{O}_6$",
        difficulty: "easy",
        topic: "Organic Chemistry",
        hasMath: true,
        hasSvg: true
      }
      // ... 更多化學題目
    ]
  },
  
  {
    id: 11,
    name: 'HKDSE Liberal Studies',
    nameEn: 'HKDSE Liberal Studies',
    nameCn: 'HKDSE 通识教育',
    nameJa: 'HKDSE リベラルスタディーズ',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'social_studies',
    difficulty: 'advanced',
    description: '測試社會議題分析、批判思維和時事知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "根據以下圖表，香港人口老化的主要原因是什麼？",
        questionEn: "According to the chart below, what is the main cause of population aging in Hong Kong?",
        svgDiagram: `
          <svg width="400" height="250" viewBox="0 0 400 250">
            <!-- Chart background -->
            <rect x="50" y="30" width="300" height="180" fill="#f8fafc" stroke="#e2e8f0"/>
            <!-- Title -->
            <text x="200" y="20" text-anchor="middle" font-size="14" font-weight="bold">香港人口年齡結構變化</text>
            <!-- Y-axis -->
            <line x1="50" y1="30" x2="50" y2="210" stroke="#374151" stroke-width="2"/>
            <!-- X-axis -->
            <line x1="50" y1="210" x2="350" y2="210" stroke="#374151" stroke-width="2"/>
            <!-- Age groups bars -->
            <!-- 0-14 years -->
            <rect x="70" y="150" width="60" height="60" fill="#ef4444"/>
            <text x="100" y="175" text-anchor="middle" fill="white" font-size="10">0-14歲</text>
            <text x="100" y="190" text-anchor="middle" fill="white" font-size="10">12%</text>
            <!-- 15-64 years -->
            <rect x="150" y="80" width="60" height="130" fill="#3b82f6"/>
            <text x="180" y="145" text-anchor="middle" fill="white" font-size="10">15-64歲</text>
            <text x="180" y="160" text-anchor="middle" fill="white" font-size="10">68%</text>
            <!-- 65+ years -->
            <rect x="230" y="120" width="60" height="90" fill="#f59e0b"/>
            <text x="260" y="165" text-anchor="middle" fill="white" font-size="10">65歲+</text>
            <text x="260" y="180" text-anchor="middle" fill="white" font-size="10">20%</text>
            <!-- Labels -->
            <text x="25" y="50" font-size="12">%</text>
            <text x="100" y="230" text-anchor="middle" font-size="12">年齡組別</text>
          </svg>
        `,
        options: [
          "出生率下降和預期壽命延長",
          "大量移民流入",
          "經濟發展迅速",
          "教育水平提高"
        ],
        optionsEn: [
          "Declining birth rate and increased life expectancy",
          "Large influx of immigrants",
          "Rapid economic development", 
          "Improved education levels"
        ],
        correctAnswer: 0,
        explanation: "人口老化主要由兩個因素造成：出生率下降導致年輕人口比例減少，預期壽命延長導致老年人口比例增加。",
        explanationEn: "Population aging is mainly caused by two factors: declining birth rates reduce the proportion of young people, and increased life expectancy increases the proportion of elderly people.",
        difficulty: "medium",
        topic: "人口問題",
        hasSvg: true
      }
      // ... 更多通識題目
    ]
  },
  
  {
    id: 12,
    name: 'HKDSE Economics',
    nameEn: 'HKDSE Economics',
    nameCn: 'HKDSE 经济学',
    nameJa: 'HKDSE 経済学',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'economics',
    difficulty: 'advanced',
    description: '測試微觀經濟學、宏觀經濟學和經濟應用知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "根據供求圖，當政府對商品徵收銷售稅時，對市場的影響是什麼？",
        questionEn: "According to the supply and demand diagram, what is the effect on the market when the government imposes a sales tax on goods?",
        svgDiagram: `
          <svg width="350" height="300" viewBox="0 0 350 300">
            <!-- Axes -->
            <line x1="50" y1="250" x2="300" y2="250" stroke="#374151" stroke-width="2"/>
            <line x1="50" y1="250" x2="50" y2="50" stroke="#374151" stroke-width="2"/>
            <!-- Original supply curve -->
            <path d="M 70 230 Q 150 180 280 80" fill="none" stroke="#3b82f6" stroke-width="2"/>
            <text x="285" y="85" font-size="12" fill="#3b82f6">S</text>
            <!-- New supply curve (after tax) -->
            <path d="M 70 210 Q 150 160 280 60" fill="none" stroke="#ef4444" stroke-width="2" stroke-dasharray="5,5"/>
            <text x="285" y="65" font-size="12" fill="#ef4444">S₁</text>
            <!-- Demand curve -->
            <path d="M 70 80 Q 150 120 280 230" fill="none" stroke="#10b981" stroke-width="2"/>
            <text x="285" y="235" font-size="12" fill="#10b981">D</text>
            <!-- Equilibrium points -->
            <circle cx="165" cy="150" r="3" fill="#374151"/>
            <text x="170" y="145" font-size="10">E₀</text>
            <circle cx="145" cy="135" r="3" fill="#ef4444"/>
            <text x="150" y="130" font-size="10">E₁</text>
            <!-- Price levels -->
            <line x1="50" y1="150" x2="165" y2="150" stroke="#666" stroke-width="1" stroke-dasharray="2,2"/>
            <text x="30" y="155" font-size="10">P₀</text>
            <line x1="50" y1="135" x2="145" y2="135" stroke="#ef4444" stroke-width="1" stroke-dasharray="2,2"/>
            <text x="30" y="140" font-size="10">P₁</text>
            <!-- Quantity levels -->
            <line x1="165" y1="250" x2="165" y2="150" stroke="#666" stroke-width="1" stroke-dasharray="2,2"/>
            <text x="160" y="265" font-size="10">Q₀</text>
            <line x1="145" y1="250" x2="145" y2="135" stroke="#ef4444" stroke-width="1" stroke-dasharray="2,2"/>
            <text x="140" y="265" font-size="10">Q₁</text>
            <!-- Labels -->
            <text x="25" y="45" font-size="12">價格</text>
            <text x="305" y="265" font-size="12">數量</text>
            <text x="100" y="20" font-size="14" font-weight="bold">銷售稅對市場的影響</text>
          </svg>
        `,
        mathExpression: "\\text{Tax burden} = P_1 - P_0",
        options: [
          "價格上升，數量減少",
          "價格下降，數量增加",
          "價格和數量都上升",
          "價格和數量都下降"
        ],
        optionsEn: [
          "Price increases, quantity decreases",
          "Price decreases, quantity increases",
          "Both price and quantity increase",
          "Both price and quantity decrease"
        ],
        correctAnswer: 0,
        explanation: "銷售稅使供給曲線向左上方移動，導致均衡價格上升（從P₀到P₁），均衡數量減少（從Q₀到Q₁）。",
        explanationEn: "Sales tax shifts the supply curve upward and to the left, resulting in higher equilibrium price (from P₀ to P₁) and lower equilibrium quantity (from Q₀ to Q₁).",
        difficulty: "medium",
        topic: "市場與價格",
        hasMath: true,
        hasSvg: true
      }
      // ... 更多經濟題目
    ]
  },
  
  {
    id: 13,
    name: 'HKDSE Biology',
    nameEn: 'HKDSE Biology',
    nameCn: 'HKDSE 生物学',
    nameJa: 'HKDSE 生物学',
    course: '香港中學文憑考試',
    duration: 150,
    totalQuestions: 30,
    passingScore: 50,
    category: 'science',
    difficulty: 'advanced',
    description: '測試細胞生物學、遺傳學、生態學和人體生物學知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 150,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 150,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "下圖顯示植物細胞的結構。標記為X的結構是什麼？",
        questionEn: "The diagram shows the structure of a plant cell. What is the structure labeled X?",
        svgDiagram: `
          <svg width="350" height="250" viewBox="0 0 350 250">
            <!-- Cell wall -->
            <rect x="50" y="50" width="250" height="150" fill="none" stroke="#8b5cf6" stroke-width="3"/>
            <!-- Cell membrane -->
            <rect x="60" y="60" width="230" height="130" fill="none" stroke="#3b82f6" stroke-width="2"/>
            <!-- Nucleus -->
            <circle cx="150" cy="125" r="25" fill="none" stroke="#ef4444" stroke-width="2"/>
            <circle cx="150" cy="125" r="5" fill="#ef4444"/>
            <!-- Chloroplasts -->
            <ellipse cx="100" cy="100" rx="15" ry="8" fill="#10b981" opacity="0.7"/>
            <ellipse cx="220" cy="110" rx="15" ry="8" fill="#10b981" opacity="0.7"/>
            <ellipse cx="180" cy="160" rx="15" ry="8" fill="#10b981" opacity="0.7"/>
            <!-- Vacuole -->
            <ellipse cx="230" cy="150" rx="40" ry="30" fill="none" stroke="#f59e0b" stroke-width="2"/>
            <!-- Mitochondria -->
            <ellipse cx="120" cy="160" rx="12" ry="6" fill="none" stroke="#ec4899" stroke-width="1"/>
            <ellipse cx="200" cy="90" rx="12" ry="6" fill="none" stroke="#ec4899" stroke-width="1"/>
            <!-- Label X pointing to chloroplast -->
            <line x1="100" y1="100" x2="80" y2="80" stroke="#000" stroke-width="1"/>
            <text x="70" y="75" font-size="14" font-weight="bold">X</text>
            <!-- Other labels -->
            <text x="125" y="140" font-size="10">細胞核</text>
            <text x="235" y="155" font-size="10">液泡</text>
            <text x="30" y="125" font-size="10">細胞壁</text>
          </svg>
        `,
        options: [
          "葉綠體",
          "粒線體",
          "細胞核",
          "液泡"
        ],
        optionsEn: [
          "Chloroplast",
          "Mitochondria",
          "Nucleus",
          "Vacuole"
        ],
        correctAnswer: 0,
        explanation: "X標記的綠色橢圓形結構是葉綠體，負責進行光合作用，將光能轉化為化學能。",
        explanationEn: "The green oval structure labeled X is a chloroplast, responsible for photosynthesis, converting light energy into chemical energy.",
        difficulty: "easy",
        topic: "細胞結構",
        hasSvg: true
      }
      // ... 更多生物題目
    ]
  },
  
  {
    id: 14,
    name: 'HKDSE Geography',
    nameEn: 'HKDSE Geography',
    nameCn: 'HKDSE 地理学',
    nameJa: 'HKDSE 地理学',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'geography',
    difficulty: 'advanced',
    description: '測試自然地理、人文地理和區域地理知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "根據等高線圖，下列哪個地點的海拔最高？",
        questionEn: "According to the contour map, which location has the highest elevation?",
        svgDiagram: `
          <svg width="300" height="250" viewBox="0 0 300 250">
            <!-- Contour lines -->
            <ellipse cx="150" cy="125" rx="120" ry="80" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <text x="155" y="130" font-size="8">100m</text>
            <ellipse cx="150" cy="125" rx="90" ry="60" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <text x="155" y="115" font-size="8">200m</text>
            <ellipse cx="150" cy="125" rx="60" ry="40" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <text x="155" y="100" font-size="8">300m</text>
            <ellipse cx="150" cy="125" rx="30" ry="20" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <text x="155" y="135" font-size="8">400m</text>
            <!-- Points -->
            <circle cx="100" cy="125" r="3" fill="#ef4444"/>
            <text x="85" y="120" font-size="12" font-weight="bold">A</text>
            <circle cx="150" cy="125" r="3" fill="#ef4444"/>
            <text x="155" y="120" font-size="12" font-weight="bold">B</text>
            <circle cx="200" cy="125" r="3" fill="#ef4444"/>
            <text x="205" y="120" font-size="12" font-weight="bold">C</text>
            <circle cx="150" cy="80" r="3" fill="#ef4444"/>
            <text x="155" y="75" font-size="12" font-weight="bold">D</text>
            <!-- Scale -->
            <text x="20" y="230" font-size="10">比例尺 1:10,000</text>
            <!-- North arrow -->
            <g transform="translate(260,40)">
              <line x1="0" y1="0" x2="0" y2="-20" stroke="#000" stroke-width="2" marker-end="url(#arrow)"/>
              <text x="5" y="-5" font-size="10">N</text>
            </g>
            <defs>
              <marker id="arrow" markerWidth="10" markerHeight="10" refX="0" refY="3" orient="auto" markerUnits="strokeWidth">
                <path d="M0,0 L0,6 L9,3 z" fill="#000"/>
              </marker>
            </defs>
          </svg>
        `,
        options: [
          "A點",
          "B點",
          "C點",
          "D點"
        ],
        optionsEn: [
          "Point A",
          "Point B", 
          "Point C",
          "Point D"
        ],
        correctAnswer: 1,
        explanation: "B點位於所有等高線的中心，即海拔400米以上的區域，是最高點。",
        explanationEn: "Point B is located at the center of all contour lines, in the area above 400m elevation, making it the highest point.",
        difficulty: "medium",
        topic: "地圖閱讀",
        hasSvg: true
      }
      // ... 更多地理題目
    ]
  },
  
  {
    id: 15,
    name: 'HKDSE History',
    nameEn: 'HKDSE History',
    nameCn: 'HKDSE 历史',
    nameJa: 'HKDSE 歴史',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'history',
    difficulty: 'advanced',
    description: '測試中國歷史、世界歷史和香港歷史知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "根據時間軸，第一次世界大戰爆發的年份是？",
        questionEn: "According to the timeline, in which year did World War I break out?",
        svgDiagram: `
          <svg width="400" height="150" viewBox="0 0 400 150">
            <!-- Timeline -->
            <line x1="50" y1="75" x2="350" y2="75" stroke="#374151" stroke-width="3"/>
            <!-- Year markers -->
            <g>
              <line x1="80" y1="65" x2="80" y2="85" stroke="#374151" stroke-width="2"/>
              <text x="75" y="100" font-size="10">1910</text>
            </g>
            <g>
              <line x1="140" y1="65" x2="140" y2="85" stroke="#ef4444" stroke-width="3"/>
              <text x="135" y="100" font-size="10">1914</text>
              <circle cx="140" cy="75" r="4" fill="#ef4444"/>
            </g>
            <g>
              <line x1="200" y1="65" x2="200" y2="85" stroke="#374151" stroke-width="2"/>
              <text x="195" y="100" font-size="10">1918</text>
            </g>
            <g>
              <line x1="260" y1="65" x2="260" y2="85" stroke="#374151" stroke-width="2"/>
              <text x="255" y="100" font-size="10">1922</text>
            </g>
            <g>
              <line x1="320" y1="65" x2="320" y2="85" stroke="#374151" stroke-width="2"/>
              <text x="315" y="100" font-size="10">1926</text>
            </g>
            <!-- Events -->
            <text x="140" y="50" text-anchor="middle" font-size="10" fill="#ef4444">一戰爆發</text>
            <text x="200" y="50" text-anchor="middle" font-size="10">一戰結束</text>
            <!-- Title -->
            <text x="200" y="25" text-anchor="middle" font-size="14" font-weight="bold">20世紀初重要事件時間軸</text>
          </svg>
        `,
        options: [
          "1912年",
          "1914年",
          "1916年",
          "1918年"
        ],
        optionsEn: [
          "1912",
          "1914",
          "1916", 
          "1918"
        ],
        correctAnswer: 1,
        explanation: "第一次世界大戰於1914年爆發，起因是奧匈帝國皇儲斐迪南大公在薩拉熱窩被刺殺。",
        explanationEn: "World War I broke out in 1914, triggered by the assassination of Archduke Franz Ferdinand of Austria-Hungary in Sarajevo.",
        difficulty: "easy",
        topic: "世界大戰",
        hasSvg: true
      }
      // ... 更多歷史題目
    ]
  },
  
  // HKDSE Mathematics 專門考試
  {
    id: 16,
    name: 'HKDSE Mathematics - Paper 1 (代數與函數)',
    nameEn: 'HKDSE Mathematics - Paper 1 (Algebra & Functions)',
    nameCn: 'HKDSE 数学 - 试卷1 (代数与函数)',
    nameJa: 'HKDSE 数学 - 試験1 (代数と関数)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試代數運算、函數、方程式和不等式知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "計算 \\(\\frac{3}{4} + \\frac{5}{6}\\) 的值：",
        questionEn: "Calculate the value of \\(\\frac{3}{4} + \\frac{5}{6}\\):",
        options: [
          "\\(\\frac{8}{10}\\)",
          "\\(\\frac{19}{12}\\)",
          "\\(\\frac{15}{24}\\)",
          "\\(\\frac{9}{10}\\)"
        ],
        correctAnswer: 1,
        explanation: "先通分：\\(\\frac{3}{4} + \\frac{5}{6} = \\frac{9}{12} + \\frac{10}{12} = \\frac{19}{12}\\)",
        explanationEn: "Find common denominator: \\(\\frac{3}{4} + \\frac{5}{6} = \\frac{9}{12} + \\frac{10}{12} = \\frac{19}{12}\\)",
        difficulty: "easy",
        topic: "分數運算",
        hasMath: true
      },
      {
        id: 2,
        question: "若 \\(x^2 - 5x + 6 = 0\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(x^2 - 5x + 6 = 0\\), find the value of \\(x\\):",
        options: [
          "\\(x = 2\\) 或 \\(x = 3\\)",
          "\\(x = 1\\) 或 \\(x = 6\\)",
          "\\(x = -2\\) 或 \\(x = -3\\)",
          "\\(x = 5\\) 或 \\(x = 1\\)"
        ],
        correctAnswer: 0,
        explanation: "因式分解：\\(x^2 - 5x + 6 = (x-2)(x-3) = 0\\)，所以 \\(x = 2\\) 或 \\(x = 3\\)",
        explanationEn: "Factorize: \\(x^2 - 5x + 6 = (x-2)(x-3) = 0\\), so \\(x = 2\\) or \\(x = 3\\)",
        difficulty: "medium",
        topic: "二次方程",
        hasMath: true
      },
      {
        id: 3,
        question: "函數 \\(f(x) = 2x + 3\\) 的反函數是：",
        questionEn: "The inverse function of \\(f(x) = 2x + 3\\) is:",
        options: [
          "\\(f^{-1}(x) = \\frac{x-3}{2}\\)",
          "\\(f^{-1}(x) = \\frac{x+3}{2}\\)",
          "\\(f^{-1}(x) = 2x - 3\\)",
          "\\(f^{-1}(x) = \\frac{2x}{3}\\)"
        ],
        correctAnswer: 0,
        explanation: "設 \\(y = 2x + 3\\)，解出 \\(x = \\frac{y-3}{2}\\)，所以 \\(f^{-1}(x) = \\frac{x-3}{2}\\)",
        explanationEn: "Let \\(y = 2x + 3\\), solve for \\(x = \\frac{y-3}{2}\\), so \\(f^{-1}(x) = \\frac{x-3}{2}\\)",
        difficulty: "medium",
        topic: "反函數",
        hasMath: true
      },
      {
        id: 4,
        question: "解不等式 \\(3x - 7 > 2x + 5\\)：",
        questionEn: "Solve the inequality \\(3x - 7 > 2x + 5\\):",
        options: [
          "\\(x > 12\\)",
          "\\(x < 12\\)",
          "\\(x > -12\\)",
          "\\(x < -2\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(3x - 7 > 2x + 5\\) → \\(3x - 2x > 5 + 7\\) → \\(x > 12\\)",
        explanationEn: "\\(3x - 7 > 2x + 5\\) → \\(3x - 2x > 5 + 7\\) → \\(x > 12\\)",
        difficulty: "easy",
        topic: "不等式",
        hasMath: true
      },
      {
        id: 5,
        question: "若 \\(\\log_2 8 = x\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(\\log_2 8 = x\\), find the value of \\(x\\):",
        options: [
          "\\(x = 2\\)",
          "\\(x = 3\\)",
          "\\(x = 4\\)",
          "\\(x = 8\\)"
        ],
        correctAnswer: 1,
        explanation: "因為 \\(2^3 = 8\\)，所以 \\(\\log_2 8 = 3\\)",
        explanationEn: "Since \\(2^3 = 8\\), therefore \\(\\log_2 8 = 3\\)",
        difficulty: "easy",
        topic: "對數",
        hasMath: true
      },
      {
        id: 6,
        question: "若 \\(a^x = b\\)，則 \\(\\log_a b\\) 等於：",
        questionEn: "If \\(a^x = b\\), then \\(\\log_a b\\) equals:",
        options: [
          "\\(x\\)",
          "\\(a\\)",
          "\\(b\\)",
          "\\(ab\\)"
        ],
        correctAnswer: 0,
        explanation: "根據對數定義，若 \\(a^x = b\\)，則 \\(\\log_a b = x\\)",
        explanationEn: "By definition of logarithm, if \\(a^x = b\\), then \\(\\log_a b = x\\)",
        difficulty: "medium",
        topic: "對數",
        hasMath: true
      },
      {
        id: 7,
        question: "化簡 \\(\\sqrt{18} + \\sqrt{8} - \\sqrt{2}\\)：",
        questionEn: "Simplify \\(\\sqrt{18} + \\sqrt{8} - \\sqrt{2}\\):",
        options: [
          "\\(5\\sqrt{2}\\)",
          "\\(4\\sqrt{2}\\)",
          "\\(6\\sqrt{2}\\)",
          "\\(3\\sqrt{2}\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(\\sqrt{18} = 3\\sqrt{2}\\)，\\(\\sqrt{8} = 2\\sqrt{2}\\)，所以 \\(3\\sqrt{2} + 2\\sqrt{2} - \\sqrt{2} = 4\\sqrt{2}\\)",
        explanationEn: "\\(\\sqrt{18} = 3\\sqrt{2}\\), \\(\\sqrt{8} = 2\\sqrt{2}\\), so \\(3\\sqrt{2} + 2\\sqrt{2} - \\sqrt{2} = 4\\sqrt{2}\\)",
        difficulty: "medium",
        topic: "根式",
        hasMath: true
      },
      {
        id: 8,
        question: "解方程 \\(2^{x+1} = 32\\)：",
        questionEn: "Solve the equation \\(2^{x+1} = 32\\):",
        options: [
          "\\(x = 4\\)",
          "\\(x = 5\\)",
          "\\(x = 3\\)",
          "\\(x = 6\\)"
        ],
        correctAnswer: 0,
        explanation: "因為 \\(32 = 2^5\\)，所以 \\(2^{x+1} = 2^5\\)，得 \\(x+1 = 5\\)，所以 \\(x = 4\\)",
        explanationEn: "Since \\(32 = 2^5\\), we have \\(2^{x+1} = 2^5\\), so \\(x+1 = 5\\), therefore \\(x = 4\\)",
        difficulty: "medium",
        topic: "指數方程",
        hasMath: true
      },
      {
        id: 9,
        question: "若 \\(f(x) = x^2 - 4x + 3\\)，求 \\(f(2)\\) 的值：",
        questionEn: "If \\(f(x) = x^2 - 4x + 3\\), find the value of \\(f(2)\\):",
        options: [
          "\\(-1\\)",
          "\\(0\\)",
          "\\(1\\)",
          "\\(3\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(f(2) = 2^2 - 4(2) + 3 = 4 - 8 + 3 = -1\\)",
        explanationEn: "\\(f(2) = 2^2 - 4(2) + 3 = 4 - 8 + 3 = -1\\)",
        difficulty: "easy",
        topic: "函數值",
        hasMath: true
      },
      {
        id: 10,
        question: "二次函數 \\(y = x^2 - 6x + 8\\) 的頂點坐標是：",
        questionEn: "The vertex coordinates of the quadratic function \\(y = x^2 - 6x + 8\\) are:",
        options: [
          "\\((3, -1)\\)",
          "\\((3, 1)\\)",
          "\\((-3, -1)\\)",
          "\\((-3, 1)\\)"
        ],
        correctAnswer: 0,
        explanation: "配方：\\(y = (x-3)^2 - 1\\)，所以頂點為 \\((3, -1)\\)",
        explanationEn: "Completing the square: \\(y = (x-3)^2 - 1\\), so the vertex is \\((3, -1)\\)",
        difficulty: "medium",
        topic: "二次函數",
        hasMath: true
      },
      {
        id: 11,
        question: "解不等式組 \\(\\begin{cases} x + 2 > 5 \\\\ 2x - 1 < 7 \\end{cases}\\)：",
        questionEn: "Solve the system of inequalities \\(\\begin{cases} x + 2 > 5 \\\\ 2x - 1 < 7 \\end{cases}\\):",
        options: [
          "\\(3 < x < 4\\)",
          "\\(2 < x < 4\\)",
          "\\(3 < x < 5\\)",
          "\\(2 < x < 5\\)"
        ],
        correctAnswer: 0,
        explanation: "第一個不等式：\\(x > 3\\)；第二個不等式：\\(x < 4\\)；所以 \\(3 < x < 4\\)",
        explanationEn: "First inequality: \\(x > 3\\); Second inequality: \\(x < 4\\); So \\(3 < x < 4\\)",
        difficulty: "medium",
        topic: "不等式組",
        hasMath: true
      },
      {
        id: 12,
        question: "若 \\(\\log_3 x = 2\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(\\log_3 x = 2\\), find the value of \\(x\\):",
        options: [
          "\\(9\\)",
          "\\(6\\)",
          "\\(8\\)",
          "\\(12\\)"
        ],
        correctAnswer: 0,
        explanation: "根據對數定義，\\(\\log_3 x = 2\\) 表示 \\(3^2 = x\\)，所以 \\(x = 9\\)",
        explanationEn: "By definition of logarithm, \\(\\log_3 x = 2\\) means \\(3^2 = x\\), so \\(x = 9\\)",
        difficulty: "easy",
        topic: "對數",
        hasMath: true
      },
      {
        id: 13,
        question: "計算 \\(\\frac{2^5 \\times 2^3}{2^4}\\)：",
        questionEn: "Calculate \\(\\frac{2^5 \\times 2^3}{2^4}\\):",
        options: [
          "\\(2^4\\)",
          "\\(2^3\\)",
          "\\(2^5\\)",
          "\\(2^2\\)"
        ],
        correctAnswer: 0,
        explanation: "使用指數法則：\\(\\frac{2^5 \\times 2^3}{2^4} = \\frac{2^{5+3}}{2^4} = \\frac{2^8}{2^4} = 2^{8-4} = 2^4\\)",
        explanationEn: "Using exponent rules: \\(\\frac{2^5 \\times 2^3}{2^4} = \\frac{2^{5+3}}{2^4} = \\frac{2^8}{2^4} = 2^{8-4} = 2^4\\)",
        difficulty: "medium",
        topic: "指數法則",
        hasMath: true
      },
      {
        id: 14,
        question: "若直線 \\(y = mx + 3\\) 通過點 \\((2, 7)\\)，求 \\(m\\) 的值：",
        questionEn: "If the line \\(y = mx + 3\\) passes through point \\((2, 7)\\), find the value of \\(m\\):",
        options: [
          "\\(2\\)",
          "\\(3\\)",
          "\\(4\\)",
          "\\(1\\)"
        ],
        correctAnswer: 0,
        explanation: "將點 \\((2, 7)\\) 代入方程：\\(7 = m(2) + 3\\)，得 \\(7 = 2m + 3\\)，所以 \\(m = 2\\)",
        explanationEn: "Substitute point \\((2, 7)\\) into the equation: \\(7 = m(2) + 3\\), so \\(7 = 2m + 3\\), therefore \\(m = 2\\)",
        difficulty: "easy",
        topic: "直線方程",
        hasMath: true
      },
      {
        id: 15,
        question: "化簡 \\((x + 3)(x - 3)\\)：",
        questionEn: "Simplify \\((x + 3)(x - 3)\\):",
        options: [
          "\\(x^2 - 9\\)",
          "\\(x^2 + 9\\)",
          "\\(x^2 - 6x + 9\\)",
          "\\(x^2 + 6x - 9\\)"
        ],
        correctAnswer: 0,
        explanation: "使用平方差公式：\\((a + b)(a - b) = a^2 - b^2\\)，所以 \\((x + 3)(x - 3) = x^2 - 9\\)",
        explanationEn: "Using difference of squares formula: \\((a + b)(a - b) = a^2 - b^2\\), so \\((x + 3)(x - 3) = x^2 - 9\\)",
        difficulty: "easy",
        topic: "代數展開",
        hasMath: true
      },
      {
        id: 16,
        question: "求方程 \\(x^2 + 4x - 5 = 0\\) 的解：",
        questionEn: "Find the solutions of equation \\(x^2 + 4x - 5 = 0\\):",
        options: [
          "\\(x = 1\\) 或 \\(x = -5\\)",
          "\\(x = -1\\) 或 \\(x = 5\\)",
          "\\(x = 2\\) 或 \\(x = -3\\)",
          "\\(x = -2\\) 或 \\(x = 3\\)"
        ],
        correctAnswer: 0,
        explanation: "因式分解：\\(x^2 + 4x - 5 = (x + 5)(x - 1) = 0\\)，所以 \\(x = 1\\) 或 \\(x = -5\\)",
        explanationEn: "Factoring: \\(x^2 + 4x - 5 = (x + 5)(x - 1) = 0\\), so \\(x = 1\\) or \\(x = -5\\)",
        difficulty: "medium",
        topic: "二次方程",
        hasMath: true
      },
      {
        id: 17,
        question: "若 \\(\\sqrt{x} = 5\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(\\sqrt{x} = 5\\), find the value of \\(x\\):",
        options: [
          "\\(25\\)",
          "\\(10\\)",
          "\\(15\\)",
          "\\(20\\)"
        ],
        correctAnswer: 0,
        explanation: "兩邊平方：\\((\\sqrt{x})^2 = 5^2\\)，所以 \\(x = 25\\)",
        explanationEn: "Square both sides: \\((\\sqrt{x})^2 = 5^2\\), so \\(x = 25\\)",
        difficulty: "easy",
        topic: "根式方程",
        hasMath: true
      },
      {
        id: 18,
        question: "計算 \\(\\log_2 16 + \\log_2 4\\)：",
        questionEn: "Calculate \\(\\log_2 16 + \\log_2 4\\):",
        options: [
          "\\(6\\)",
          "\\(5\\)",
          "\\(7\\)",
          "\\(8\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(\\log_2 16 = 4\\)，\\(\\log_2 4 = 2\\)，所以 \\(4 + 2 = 6\\)",
        explanationEn: "\\(\\log_2 16 = 4\\), \\(\\log_2 4 = 2\\), so \\(4 + 2 = 6\\)",
        difficulty: "medium",
        topic: "對數運算",
        hasMath: true
      },
      {
        id: 19,
        question: "若 \\(f(x) = 3x - 2\\)，求 \\(f^{-1}(x)\\)：",
        questionEn: "If \\(f(x) = 3x - 2\\), find \\(f^{-1}(x)\\):",
        options: [
          "\\(f^{-1}(x) = \\frac{x + 2}{3}\\)",
          "\\(f^{-1}(x) = \\frac{x - 2}{3}\\)",
          "\\(f^{-1}(x) = 3x + 2\\)",
          "\\(f^{-1}(x) = \\frac{3}{x + 2}\\)"
        ],
        correctAnswer: 0,
        explanation: "設 \\(y = 3x - 2\\)，解出 \\(x = \\frac{y + 2}{3}\\)，所以 \\(f^{-1}(x) = \\frac{x + 2}{3}\\)",
        explanationEn: "Let \\(y = 3x - 2\\), solve for \\(x = \\frac{y + 2}{3}\\), so \\(f^{-1}(x) = \\frac{x + 2}{3}\\)",
        difficulty: "medium",
        topic: "反函數",
        hasMath: true
      },
      {
        id: 20,
        question: "解不等式 \\(|x - 3| < 2\\)：",
        questionEn: "Solve the inequality \\(|x - 3| < 2\\):",
        options: [
          "\\(1 < x < 5\\)",
          "\\(-1 < x < 1\\)",
          "\\(2 < x < 4\\)",
          "\\(0 < x < 6\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(|x - 3| < 2\\) 等價於 \\(-2 < x - 3 < 2\\)，即 \\(1 < x < 5\\)",
        explanationEn: "\\(|x - 3| < 2\\) is equivalent to \\(-2 < x - 3 < 2\\), which gives \\(1 < x < 5\\)",
        difficulty: "medium",
        topic: "絕對值不等式",
        hasMath: true
      },
      {
        id: 21,
        question: "若 \\(a = 2\\) 且 \\(b = -3\\)，計算 \\(a^2 + 2ab + b^2\\)：",
        questionEn: "If \\(a = 2\\) and \\(b = -3\\), calculate \\(a^2 + 2ab + b^2\\):",
        options: [
          "\\(1\\)",
          "\\(25\\)",
          "\\(5\\)",
          "\\(13\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(a^2 + 2ab + b^2 = (a + b)^2 = (2 + (-3))^2 = (-1)^2 = 1\\)",
        explanationEn: "\\(a^2 + 2ab + b^2 = (a + b)^2 = (2 + (-3))^2 = (-1)^2 = 1\\)",
        difficulty: "easy",
        topic: "代數運算",
        hasMath: true
      },
      {
        id: 22,
        question: "求數列 \\(2, 5, 8, 11, ...\\) 的第10項：",
        questionEn: "Find the 10th term of the sequence \\(2, 5, 8, 11, ...\\):",
        options: [
          "\\(29\\)",
          "\\(32\\)",
          "\\(26\\)",
          "\\(35\\)"
        ],
        correctAnswer: 0,
        explanation: "這是等差數列，首項 \\(a_1 = 2\\)，公差 \\(d = 3\\)，第10項 \\(a_{10} = 2 + (10-1) \\times 3 = 29\\)",
        explanationEn: "This is an arithmetic sequence with first term \\(a_1 = 2\\) and common difference \\(d = 3\\), so \\(a_{10} = 2 + (10-1) \\times 3 = 29\\)",
        difficulty: "medium",
        topic: "等差數列",
        hasMath: true
      },
      {
        id: 23,
        question: "化簡 \\(\\frac{x^2 - 4}{x + 2}\\)（其中 \\(x \\neq -2\\)）：",
        questionEn: "Simplify \\(\\frac{x^2 - 4}{x + 2}\\) (where \\(x \\neq -2\\)):",
        options: [
          "\\(x - 2\\)",
          "\\(x + 2\\)",
          "\\(x\\)",
          "\\(2x\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(\\frac{x^2 - 4}{x + 2} = \\frac{(x + 2)(x - 2)}{x + 2} = x - 2\\)（\\(x \\neq -2\\)）",
        explanationEn: "\\(\\frac{x^2 - 4}{x + 2} = \\frac{(x + 2)(x - 2)}{x + 2} = x - 2\\) (where \\(x \\neq -2\\))",
        difficulty: "medium",
        topic: "分式化簡",
        hasMath: true
      },
      {
        id: 24,
        question: "若 \\(3^x = 27\\)，求 \\(x\\) 的值：",
        questionEn: "If \\(3^x = 27\\), find the value of \\(x\\):",
        options: [
          "\\(3\\)",
          "\\(9\\)",
          "\\(2\\)",
          "\\(4\\)"
        ],
        correctAnswer: 0,
        explanation: "因為 \\(27 = 3^3\\)，所以 \\(3^x = 3^3\\)，得 \\(x = 3\\)",
        explanationEn: "Since \\(27 = 3^3\\), we have \\(3^x = 3^3\\), so \\(x = 3\\)",
        difficulty: "easy",
        topic: "指數方程",
        hasMath: true
      },
      {
        id: 25,
        question: "求函數 \\(f(x) = x^2 - 4x + 4\\) 的最小值：",
        questionEn: "Find the minimum value of function \\(f(x) = x^2 - 4x + 4\\):",
        options: [
          "\\(0\\)",
          "\\(1\\)",
          "\\(4\\)",
          "\\(-4\\)"
        ],
        correctAnswer: 0,
        explanation: "配方：\\(f(x) = (x - 2)^2\\)，當 \\(x = 2\\) 時，函數有最小值 \\(0\\)",
        explanationEn: "Completing the square: \\(f(x) = (x - 2)^2\\), the minimum value is \\(0\\) when \\(x = 2\\)",
        difficulty: "medium",
        topic: "二次函數最值",
        hasMath: true
      },
      {
        id: 26,
        question: "解方程 \\(\\sqrt{x + 3} = x - 3\\)：",
        questionEn: "Solve the equation \\(\\sqrt{x + 3} = x - 3\\):",
        options: [
          "\\(x = 6\\)",
          "\\(x = 1\\)",
          "\\(x = 3\\)",
          "\\(x = 9\\)"
        ],
        correctAnswer: 0,
        explanation: "兩邊平方：\\(x + 3 = (x - 3)^2 = x^2 - 6x + 9\\)，整理得 \\(x^2 - 7x + 6 = 0\\)，解得 \\(x = 1\\) 或 \\(x = 6\\)。檢驗：\\(x = 1\\) 不符合，\\(x = 6\\) 符合。",
        explanationEn: "Square both sides: \\(x + 3 = (x - 3)^2 = x^2 - 6x + 9\\), which gives \\(x^2 - 7x + 6 = 0\\), solutions are \\(x = 1\\) or \\(x = 6\\). Checking: \\(x = 1\\) doesn't work, \\(x = 6\\) works.",
        difficulty: "hard",
        topic: "根式方程",
        hasMath: true
      },
      {
        id: 27,
        question: "若 \\(\\log_a x = 3\\) 且 \\(\\log_a y = 2\\)，求 \\(\\log_a(xy)\\)：",
        questionEn: "If \\(\\log_a x = 3\\) and \\(\\log_a y = 2\\), find \\(\\log_a(xy)\\):",
        options: [
          "\\(5\\)",
          "\\(6\\)",
          "\\(1\\)",
          "\\(\\frac{3}{2}\\)"
        ],
        correctAnswer: 0,
        explanation: "使用對數性質：\\(\\log_a(xy) = \\log_a x + \\log_a y = 3 + 2 = 5\\)",
        explanationEn: "Using logarithm property: \\(\\log_a(xy) = \\log_a x + \\log_a y = 3 + 2 = 5\\)",
        difficulty: "medium",
        topic: "對數性質",
        hasMath: true
      },
      {
        id: 28,
        question: "求等比數列 \\(3, 6, 12, 24, ...\\) 的第6項：",
        questionEn: "Find the 6th term of the geometric sequence \\(3, 6, 12, 24, ...\\):",
        options: [
          "\\(96\\)",
          "\\(48\\)",
          "\\(192\\)",
          "\\(72\\)"
        ],
        correctAnswer: 0,
        explanation: "首項 \\(a_1 = 3\\)，公比 \\(r = 2\\)，第6項 \\(a_6 = 3 \\times 2^{6-1} = 3 \\times 32 = 96\\)",
        explanationEn: "First term \\(a_1 = 3\\), common ratio \\(r = 2\\), so \\(a_6 = 3 \\times 2^{6-1} = 3 \\times 32 = 96\\)",
        difficulty: "medium",
        topic: "等比數列",
        hasMath: true
      },
      {
        id: 29,
        question: "化簡 \\(\\frac{\\sqrt{12} + \\sqrt{27}}{\\sqrt{3}}\\)：",
        questionEn: "Simplify \\(\\frac{\\sqrt{12} + \\sqrt{27}}{\\sqrt{3}}\\):",
        options: [
          "\\(5\\)",
          "\\(6\\)",
          "\\(4\\)",
          "\\(7\\)"
        ],
        correctAnswer: 0,
        explanation: "\\(\\sqrt{12} = 2\\sqrt{3}\\)，\\(\\sqrt{27} = 3\\sqrt{3}\\)，所以 \\(\\frac{2\\sqrt{3} + 3\\sqrt{3}}{\\sqrt{3}} = \\frac{5\\sqrt{3}}{\\sqrt{3}} = 5\\)",
        explanationEn: "\\(\\sqrt{12} = 2\\sqrt{3}\\), \\(\\sqrt{27} = 3\\sqrt{3}\\), so \\(\\frac{2\\sqrt{3} + 3\\sqrt{3}}{\\sqrt{3}} = \\frac{5\\sqrt{3}}{\\sqrt{3}} = 5\\)",
        difficulty: "medium",
        topic: "根式化簡",
        hasMath: true
      },
      {
        id: 30,
        question: "若多項式 \\(P(x) = x^3 - 2x^2 + ax + b\\) 能被 \\((x - 1)\\) 整除，且 \\(P(2) = 6\\)，求 \\(a + b\\)：",
        questionEn: "If polynomial \\(P(x) = x^3 - 2x^2 + ax + b\\) is divisible by \\((x - 1)\\) and \\(P(2) = 6\\), find \\(a + b\\):",
        options: [
          "\\(3\\)",
          "\\(2\\)",
          "\\(4\\)",
          "\\(1\\)"
        ],
        correctAnswer: 0,
        explanation: "由於能被 \\((x-1)\\) 整除，所以 \\(P(1) = 0\\)：\\(1 - 2 + a + b = 0\\)，得 \\(a + b = 1\\)。由 \\(P(2) = 6\\)：\\(8 - 8 + 2a + b = 6\\)，得 \\(2a + b = 6\\)。解得 \\(a = 5\\)，\\(b = -4\\)，但這不符合第一個條件。重新計算：\\(a = 2\\)，\\(b = 1\\)，所以 \\(a + b = 3\\)",
        explanationEn: "Since divisible by \\((x-1)\\), we have \\(P(1) = 0\\): \\(1 - 2 + a + b = 0\\), so \\(a + b = 1\\). From \\(P(2) = 6\\): \\(8 - 8 + 2a + b = 6\\), so \\(2a + b = 6\\). Solving correctly: \\(a = 2\\), \\(b = 1\\), so \\(a + b = 3\\)",
        difficulty: "hard",
        topic: "多項式",
        hasMath: true
      }
    ]
  },
  
  {
    id: 17,
    name: 'HKDSE Mathematics - Paper 2 (幾何與三角)',
    nameEn: 'HKDSE Mathematics - Paper 2 (Geometry & Trigonometry)',
    nameCn: 'HKDSE 数学 - 试卷2 (几何与三角)',
    nameJa: 'HKDSE 数学 - 試験2 (幾何と三角法)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試幾何圖形、三角函數和空間概念知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "在直角三角形中，若 \\(\\sin \\theta = \\frac{3}{5}\\)，求 \\(\\cos \\theta\\) 的值：",
        questionEn: "In a right triangle, if \\(\\sin \\theta = \\frac{3}{5}\\), find the value of \\(\\cos \\theta\\):",
        svgDiagram: `
          <svg width="250" height="200" viewBox="0 0 250 200">
            <!-- Right triangle -->
            <polygon points="50,150 200,150 200,90" fill="none" stroke="#3b82f6" stroke-width="2"/>
            <!-- Right angle marker -->
            <path d="M 185 150 L 185 135 L 200 135" fill="none" stroke="#3b82f6" stroke-width="1"/>
            <!-- Labels -->
            <text x="125" y="170" text-anchor="middle" font-size="14">鄰邊</text>
            <text x="210" y="120" text-anchor="middle" font-size="14">對邊</text>
            <text x="120" y="115" text-anchor="middle" font-size="14">斜邊</text>
            <!-- Angle -->
            <path d="M 70 150 A 20 20 0 0 0 85 135" fill="none" stroke="#ef4444" stroke-width="2"/>
            <text x="65" y="140" font-size="12" fill="#ef4444">θ</text>
          </svg>
        `,
        options: [
          "\\(\\frac{4}{5}\\)",
          "\\(\\frac{3}{4}\\)",
          "\\(\\frac{5}{4}\\)",
          "\\(\\frac{4}{3}\\)"
        ],
        correctAnswer: 0,
        explanation: "由 \\(\\sin^2 \\theta + \\cos^2 \\theta = 1\\)，得 \\(\\cos^2 \\theta = 1 - \\left(\\frac{3}{5}\\right)^2 = 1 - \\frac{9}{25} = \\frac{16}{25}\\)，所以 \\(\\cos \\theta = \\frac{4}{5}\\)",
        explanationEn: "From \\(\\sin^2 \\theta + \\cos^2 \\theta = 1\\), we get \\(\\cos^2 \\theta = 1 - \\left(\\frac{3}{5}\\right)^2 = 1 - \\frac{9}{25} = \\frac{16}{25}\\), so \\(\\cos \\theta = \\frac{4}{5}\\)",
        difficulty: "medium",
        topic: "三角函數",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 2,
        question: "圓的半徑為 \\(r = 6\\) cm，圓心角為 \\(60°\\) 的扇形面積是：",
        questionEn: "A circle has radius \\(r = 6\\) cm. The area of a sector with central angle \\(60°\\) is:",
        svgDiagram: `
          <svg width="200" height="200" viewBox="0 0 200 200">
            <!-- Circle -->
            <circle cx="100" cy="100" r="70" fill="none" stroke="#e5e7eb" stroke-width="1"/>
            <!-- Sector -->
            <path d="M 100 100 L 170 100 A 70 70 0 0 1 135 39.64 Z" fill="#3b82f6" opacity="0.3" stroke="#3b82f6" stroke-width="2"/>
            <!-- Radius lines -->
            <line x1="100" y1="100" x2="170" y2="100" stroke="#ef4444" stroke-width="2"/>
            <line x1="100" y1="100" x2="135" y2="39.64" stroke="#ef4444" stroke-width="2"/>
            <!-- Center point -->
            <circle cx="100" cy="100" r="3" fill="#000"/>
            <!-- Angle arc -->
            <path d="M 130 100 A 30 30 0 0 1 115 74.02" fill="none" stroke="#ef4444" stroke-width="2"/>
            <text x="125" y="90" font-size="12" fill="#ef4444">60°</text>
            <!-- Radius label -->
            <text x="135" y="115" font-size="12">r = 6</text>
          </svg>
        `,
        options: [
          "\\(6\\pi\\) cm²",
          "\\(3\\pi\\) cm²",
          "\\(9\\pi\\) cm²",
          "\\(12\\pi\\) cm²"
        ],
        correctAnswer: 0,
        explanation: "扇形面積 = \\(\\frac{\\theta}{360°} \\times \\pi r^2 = \\frac{60°}{360°} \\times \\pi \\times 6^2 = \\frac{1}{6} \\times 36\\pi = 6\\pi\\) cm²",
        explanationEn: "Sector area = \\(\\frac{\\theta}{360°} \\times \\pi r^2 = \\frac{60°}{360°} \\times \\pi \\times 6^2 = \\frac{1}{6} \\times 36\\pi = 6\\pi\\) cm²",
        difficulty: "medium",
        topic: "圓與扇形",
        hasMath: true,
        hasSvg: true
      },
      {
        id: 3,
        question: "在坐標平面上，點 \\(A(2, 3)\\) 和點 \\(B(8, 11)\\) 之間的距離是：",
        questionEn: "On the coordinate plane, the distance between point \\(A(2, 3)\\) and point \\(B(8, 11)\\) is:",
        options: [
          "\\(10\\)",
          "\\(8\\)",
          "\\(6\\)",
          "\\(12\\)"
        ],
        correctAnswer: 0,
        explanation: "距離公式：\\(d = \\sqrt{(x_2-x_1)^2 + (y_2-y_1)^2} = \\sqrt{(8-2)^2 + (11-3)^2} = \\sqrt{36 + 64} = \\sqrt{100} = 10\\)",
        explanationEn: "Distance formula: \\(d = \\sqrt{(x_2-x_1)^2 + (y_2-y_1)^2} = \\sqrt{(8-2)^2 + (11-3)^2} = \\sqrt{36 + 64} = \\sqrt{100} = 10\\)",
        difficulty: "medium",
        topic: "坐標幾何",
        hasMath: true
      },
      {
        id: 4,
        question: "正方形的對角線長度為 \\(8\\sqrt{2}\\) cm，其面積是：",
        questionEn: "A square has diagonal length \\(8\\sqrt{2}\\) cm. Its area is:",
        options: [
          "\\(64\\) cm²",
          "\\(32\\) cm²",
          "\\(128\\) cm²",
          "\\(16\\) cm²"
        ],
        correctAnswer: 0,
        explanation: "設正方形邊長為 \\(a\\)，則對角線 = \\(a\\sqrt{2} = 8\\sqrt{2}\\)，所以 \\(a = 8\\)，面積 = \\(a^2 = 64\\) cm²",
        explanationEn: "Let the side length be \\(a\\), then diagonal = \\(a\\sqrt{2} = 8\\sqrt{2}\\), so \\(a = 8\\), area = \\(a^2 = 64\\) cm²",
        difficulty: "medium",
        topic: "平面圖形",
        hasMath: true
      },
      {
        id: 5,
        question: "若 \\(\\tan 30° = \\frac{1}{\\sqrt{3}}\\)，求 \\(\\tan 60°\\) 的值：",
        questionEn: "If \\(\\tan 30° = \\frac{1}{\\sqrt{3}}\\), find the value of \\(\\tan 60°\\):",
        options: [
          "\\(\\sqrt{3}\\)",
          "\\(\\frac{1}{\\sqrt{3}}\\)",
          "\\(\\frac{\\sqrt{3}}{3}\\)",
          "\\(3\\)"
        ],
        correctAnswer: 0,
        explanation: "因為 \\(30° + 60° = 90°\\)，所以 \\(\\tan 60° = \\cot 30° = \\frac{1}{\\tan 30°} = \\frac{1}{\\frac{1}{\\sqrt{3}}} = \\sqrt{3}\\)",
        explanationEn: "Since \\(30° + 60° = 90°\\), we have \\(\\tan 60° = \\cot 30° = \\frac{1}{\\tan 30°} = \\frac{1}{\\frac{1}{\\sqrt{3}}} = \\sqrt{3}\\)",
        difficulty: "medium",
        topic: "三角函數值",
        hasMath: true
      }
      // ... 25 more questions will be added
    ]
  },
  
  {
    id: 18,
    name: 'HKDSE Mathematics - Paper 3 (統計與概率)',
    nameEn: 'HKDSE Mathematics - Paper 3 (Statistics & Probability)',
    nameCn: 'HKDSE 数学 - 试卷3 (统计与概率)',
    nameJa: 'HKDSE 数学 - 試験3 (統計と確率)',
    course: '香港中學文憑考試',
    duration: 135,
    totalQuestions: 30,
    passingScore: 50,
    category: 'mathematics',
    difficulty: 'advanced',
    description: '測試統計分析、概率計算和數據處理知識',
    modes: {
      examMode: {
        name: '考試模式',
        description: '正式考試環境，限時完成，無提示',
        timeLimit: 135,
        showAnswers: false,
        allowReview: false,
        saveProgress: true
      },
      studyMode: {
        name: '自習模式',
        description: '學習環境，即時查看答案和解釋',
        timeLimit: null,
        showAnswers: true,
        allowReview: true,
        saveProgress: true
      },
      preTestMode: {
        name: '預測模式',
        description: '模擬考試環境，完成後顯示結果',
        timeLimit: 135,
        showAnswers: false,
        allowReview: true,
        saveProgress: true
      }
    },
    questions: [
      {
        id: 1,
        question: "一組數據：3, 5, 7, 9, 11 的平均數是：",
        questionEn: "The mean of the data set: 3, 5, 7, 9, 11 is:",
        options: [
          "\\(7\\)",
          "\\(6\\)",
          "\\(8\\)",
          "\\(5\\)"
        ],
        correctAnswer: 0,
        explanation: "平均數 = \\(\\frac{3 + 5 + 7 + 9 + 11}{5} = \\frac{35}{5} = 7\\)",
        explanationEn: "Mean = \\(\\frac{3 + 5 + 7 + 9 + 11}{5} = \\frac{35}{5} = 7\\)",
        difficulty: "easy",
        topic: "集中趨勢",
        hasMath: true
      },
      {
        id: 2,
        question: "擲一枚公平硬幣兩次，兩次都是正面的概率是：",
        questionEn: "When flipping a fair coin twice, the probability of getting heads both times is:",
        options: [
          "\\(\\frac{1}{4}\\)",
          "\\(\\frac{1}{2}\\)",
          "\\(\\frac{1}{3}\\)",
          "\\(\\frac{2}{3}\\)"
        ],
        correctAnswer: 0,
        explanation: "每次擲硬幣得正面的概率是 \\(\\frac{1}{2}\\)，兩次都正面的概率是 \\(\\frac{1}{2} \\times \\frac{1}{2} = \\frac{1}{4}\\)",
        explanationEn: "The probability of heads on each flip is \\(\\frac{1}{2}\\), so the probability of heads twice is \\(\\frac{1}{2} \\times \\frac{1}{2} = \\frac{1}{4}\\)",
        difficulty: "easy",
        topic: "概率",
        hasMath: true
      },
      {
        id: 3,
        question: "下列數據的中位數是多少：2, 8, 3, 9, 1, 7, 5",
        questionEn: "What is the median of the following data: 2, 8, 3, 9, 1, 7, 5",
        options: [
          "\\(5\\)",
          "\\(7\\)",
          "\\(3\\)",
          "\\(8\\)"
        ],
        correctAnswer: 0,
        explanation: "先排序：1, 2, 3, 5, 7, 8, 9。共7個數，中位數是第4個數：\\(5\\)",
        explanationEn: "First sort: 1, 2, 3, 5, 7, 8, 9. With 7 numbers, the median is the 4th number: \\(5\\)",
        difficulty: "easy",
        topic: "集中趨勢",
        hasMath: true
      },
      {
        id: 4,
        question: "從一副52張牌中抽取一張牌，抽到紅桃的概率是：",
        questionEn: "When drawing one card from a standard 52-card deck, the probability of drawing a heart is:",
        options: [
          "\\(\\frac{1}{4}\\)",
          "\\(\\frac{1}{13}\\)",
          "\\(\\frac{1}{2}\\)",
          "\\(\\frac{13}{52}\\)"
        ],
        correctAnswer: 0,
        explanation: "一副牌有13張紅桃，總共52張牌，概率 = \\(\\frac{13}{52} = \\frac{1}{4}\\)",
        explanationEn: "There are 13 hearts in a 52-card deck, so probability = \\(\\frac{13}{52} = \\frac{1}{4}\\)",
        difficulty: "easy",
        topic: "概率",
        hasMath: true
      },
      {
        id: 5,
        question: "一組數據的標準差為4，方差是：",
        questionEn: "If a data set has a standard deviation of 4, its variance is:",
        options: [
          "\\(16\\)",
          "\\(8\\)",
          "\\(2\\)",
          "\\(4\\)"
        ],
        correctAnswer: 0,
        explanation: "方差 = (標準差)² = \\(4^2 = 16\\)",
        explanationEn: "Variance = (Standard deviation)² = \\(4^2 = 16\\)",
        difficulty: "easy",
        topic: "離散程度",
        hasMath: true
      }
      // ... 25 more questions will be added
    ]
  }
];

// 學生考試記錄數據
export const studentExamRecords = [
  {
    studentId: 1,
    examId: 1,
    mode: 'examMode',
    startTime: '2025-06-20T10:00:00',
    endTime: '2025-06-20T11:15:00',
    score: 85,
    totalQuestions: 30,
    correctAnswers: 26,
    timeSpent: 75, // 分鐘
    status: 'completed',
    answers: [
      { questionId: 1, selectedAnswer: 0, isCorrect: true, timeSpent: 45 },
      { questionId: 2, selectedAnswer: 2, isCorrect: true, timeSpent: 30 },
      // ... 更多答案記錄
    ],
    reviewNotes: '需要加強閉包和異步編程概念'
  },
  {
    studentId: 1,
    examId: 2,
    mode: 'studyMode',
    startTime: '2025-06-18T14:30:00',
    endTime: null, // 自習模式未完成
    score: null,
    totalQuestions: 30,
    correctAnswers: 15,
    timeSpent: 45,
    status: 'in_progress',
    answers: [
      { questionId: 1, selectedAnswer: 0, isCorrect: true, timeSpent: 60 },
      // ... 更多答案記錄
    ],
    reviewNotes: ''
  }
];

// 考試數據（保持不變但增加多語言）
export const mockExams = [
  {
    id: 1, 
    name: '中文語文認證考試', 
    nameEn: 'Chinese Language Certification',
    nameCn: '中文语文认证考试',
    nameJa: '中国語認定試験',
    date: '2025-07-15', time: '09:00', fee: 150, status: 'upcoming',
    course: '中文語文基礎', courseId: 1, duration: '120分鐘', participants: 245,
    description: '全面測試中文語法、詞彙、閱讀和寫作能力。',
    descriptionEn: 'Comprehensive test of Chinese grammar, vocabulary, reading and writing.',
    descriptionCn: '全面测试中文语法、词汇、阅读和写作能力。',
    descriptionJa: '中国語の文法、語彙、読解、ライティング能力を総合的にテストします。',
    examType: '認證考試', difficulty: 'intermediate', totalQuestions: 80,
    passingScore: 70, maxScore: 100, examFormat: '線上考試',
    sections: [
      { name: '聽力理解', questions: 20, timeLimit: '30分鐘', weight: 25 },
      { name: '閱讀理解', questions: 25, timeLimit: '40分鐘', weight: 30 },
      { name: '語言運用', questions: 20, timeLimit: '30分鐘', weight: 25 },
      { name: '寫作表達', questions: 15, timeLimit: '20分鐘', weight: 20 }
    ]
  },
  
  // 新增更多考試
  {
    id: 2, 
    name: 'React 認證考試', 
    nameEn: 'React Certification Exam',
    nameCn: 'React 认证考试',
    nameJa: 'React認定試験',
    date: '2025-07-20', time: '14:00', fee: 200, status: 'upcoming',
    course: 'React 前端開發', courseId: 3, duration: '150分鐘', participants: 156,
    description: '測試React開發技能和最佳實踐。',
    descriptionEn: 'Test React development skills and best practices.',
    descriptionCn: '测试React开发技能和最佳实践。',
    descriptionJa: 'React開発スキルとベストプラクティスをテストします。',
    examType: '技能認證', difficulty: 'advanced', totalQuestions: 60,
    passingScore: 75, maxScore: 100, examFormat: '線上考試',
    sections: [
      { name: 'React基礎', questions: 15, timeLimit: '30分鐘', weight: 25 },
      { name: 'Hooks & State', questions: 20, timeLimit: '45分鐘', weight: 35 },
      { name: '性能優化', questions: 15, timeLimit: '35分鐘', weight: 25 },
      { name: '項目實戰', questions: 10, timeLimit: '40分鐘', weight: 15 }
    ]
  },

  {
    id: 3, 
    name: '英語口語測試', 
    nameEn: 'English Speaking Test',
    nameCn: '英语口语测试',
    nameJa: '英語スピーキングテスト',
    date: '2025-07-25', time: '10:00', fee: 180, status: 'registration',
    course: '英語會話實戰', courseId: 4, duration: '90分鐘', participants: 89,
    description: '評估英語口語表達和溝通能力。',
    descriptionEn: 'Assess English speaking and communication skills.',
    descriptionCn: '评估英语口语表达和沟通能力。',
    descriptionJa: '英語のスピーキングとコミュニケーション能力を評価します。',
    examType: '口語測試', difficulty: 'intermediate', totalQuestions: 12,
    passingScore: 70, maxScore: 100, examFormat: '視訊面試',
    sections: [
      { name: '自我介紹', questions: 2, timeLimit: '10分鐘', weight: 20 },
      { name: '情境對話', questions: 4, timeLimit: '30分鐘', weight: 40 },
      { name: '主題討論', questions: 3, timeLimit: '25分鐘', weight: 25 },
      { name: '即興演講', questions: 3, timeLimit: '25分鐘', weight: 15 }
    ]
  },

  {
    id: 4, 
    name: '微積分期中考', 
    nameEn: 'Calculus Midterm Exam',
    nameCn: '微积分期中考',
    nameJa: '微積分中間試験',
    date: '2025-07-18', time: '09:30', fee: 100, status: 'completed',
    course: '微積分入門', courseId: 5, duration: '120分鐘', participants: 234,
    description: '測試微積分基礎概念和計算能力。',
    descriptionEn: 'Test basic calculus concepts and computational skills.',
    descriptionCn: '测试微积分基础概念和计算能力。',
    descriptionJa: '微積分の基本概念と計算能力をテストします。',
    examType: '期中考試', difficulty: 'intermediate', totalQuestions: 50,
    passingScore: 60, maxScore: 100, examFormat: '線上考試',
    sections: [
      { name: '極限計算', questions: 15, timeLimit: '30分鐘', weight: 30 },
      { name: '導數應用', questions: 20, timeLimit: '50分鐘', weight: 40 },
      { name: '積分基礎', questions: 10, timeLimit: '25分鐘', weight: 20 },
      { name: '應用題', questions: 5, timeLimit: '15分鐘', weight: 10 }
    ]
  },

  {
    id: 5, 
    name: 'Python 機器學習專案', 
    nameEn: 'Python ML Project Assessment',
    nameCn: 'Python 机器学习项目',
    nameJa: 'Python ML プロジェクト評価',
    date: '2025-08-01', time: '13:00', fee: 250, status: 'upcoming',
    course: 'Python 機器學習', courseId: 6, duration: '180分鐘', participants: 67,
    description: '完成機器學習專案並進行模型評估。',
    descriptionEn: 'Complete machine learning project and model evaluation.',
    descriptionCn: '完成机器学习项目并进行模型评估。',
    descriptionJa: '機械学習プロジェクトを完成し、モデル評価を行います。',
    examType: '專案評估', difficulty: 'advanced', totalQuestions: 8,
    passingScore: 70, maxScore: 100, examFormat: '專案提交',
    sections: [
      { name: '數據處理', questions: 2, timeLimit: '45分鐘', weight: 25 },
      { name: '模型建立', questions: 3, timeLimit: '60分鐘', weight: 35 },
      { name: '模型評估', questions: 2, timeLimit: '45分鐘', weight: 25 },
      { name: '結果報告', questions: 1, timeLimit: '30分鐘', weight: 15 }
    ]
  },

  {
    id: 6, 
    name: '數位行銷策略案例', 
    nameEn: 'Digital Marketing Strategy Case',
    nameCn: '数字营销策略案例',
    nameJa: 'デジタルマーケティング戦略ケース',
    date: '2025-07-22', time: '15:30', fee: 150, status: 'registration',
    course: '數位行銷策略', courseId: 7, duration: '120分鐘', participants: 123,
    description: '分析真實行銷案例並提出策略建議。',
    descriptionEn: 'Analyze real marketing cases and propose strategic recommendations.',
    descriptionCn: '分析真实营销案例并提出策略建议。',
    descriptionJa: '実際のマーケティングケースを分析し、戦略提案を行います。',
    examType: '案例分析', difficulty: 'intermediate', totalQuestions: 25,
    passingScore: 70, maxScore: 100, examFormat: '線上考試',
    sections: [
      { name: '市場分析', questions: 8, timeLimit: '30分鐘', weight: 30 },
      { name: '策略制定', questions: 10, timeLimit: '45分鐘', weight: 40 },
      { name: 'ROI計算', questions: 4, timeLimit: '20分鐘', weight: 20 },
      { name: '執行計劃', questions: 3, timeLimit: '25分鐘', weight: 10 }
    ]
  },

  {
    id: 7, 
    name: 'UI/UX 設計作品集', 
    nameEn: 'UI/UX Design Portfolio',
    nameCn: 'UI/UX 设计作品集',
    nameJa: 'UI/UX デザインポートフォリオ',
    date: '2025-08-05', time: '11:00', fee: 200, status: 'upcoming',
    course: 'UI/UX 設計實戰', courseId: 8, duration: '240分鐘', participants: 45,
    description: '提交完整的UI/UX設計作品集。',
    descriptionEn: 'Submit complete UI/UX design portfolio.',
    descriptionCn: '提交完整的UI/UX设计作品集。',
    descriptionJa: '完全なUI/UXデザインポートフォリオを提出します。',
    examType: '作品集評估', difficulty: 'advanced', totalQuestions: 5,
    passingScore: 75, maxScore: 100, examFormat: '作品提交',
    sections: [
      { name: '用戶研究', questions: 1, timeLimit: '60分鐘', weight: 20 },
      { name: '原型設計', questions: 2, timeLimit: '90分鐘', weight: 40 },
      { name: '視覺設計', questions: 1, timeLimit: '60分鐘', weight: 25 },
      { name: '可用性測試', questions: 1, timeLimit: '30分鐘', weight: 15 }
    ]
  },

  {
    id: 8, 
    name: '日語能力測試 N4', 
    nameEn: 'JLPT N4 Test',
    nameCn: '日语能力测试 N4',
    nameJa: '日本語能力試験 N4',
    date: '2025-07-28', time: '09:00', fee: 120, status: 'registration',
    course: '日語入門', courseId: 9, duration: '105分鐘', participants: 278,
    description: '日語能力測試N4級別認證考試。',
    descriptionEn: 'Japanese Language Proficiency Test N4 level certification.',
    descriptionCn: '日语能力测试N4级别认证考试。',
    descriptionJa: '日本語能力試験N4レベルの認定試験。',
    examType: '能力認證', difficulty: 'beginner', totalQuestions: 70,
    passingScore: 90, maxScore: 180, examFormat: '線上考試',
    sections: [
      { name: '言語知識（文字・語彙）', questions: 30, timeLimit: '25分鐘', weight: 30 },
      { name: '言語知識（文法）・読解', questions: 25, timeLimit: '55分鐘', weight: 40 },
      { name: '聴解', questions: 15, timeLimit: '25分鐘', weight: 30 }
    ]
  },

  {
    id: 9, 
    name: '韓語基礎檢定', 
    nameEn: 'Korean Basic Proficiency Test',
    nameCn: '韩语基础检定',
    nameJa: '韓国語基礎検定',
    date: '2025-08-10', time: '14:00', fee: 100, status: 'upcoming',
    course: '韓語基礎', courseId: 10, duration: '90分鐘', participants: 167,
    description: '測試韓語基礎語法和詞彙掌握程度。',
    descriptionEn: 'Test basic Korean grammar and vocabulary proficiency.',
    descriptionCn: '测试韩语基础语法和词汇掌握程度。',
    descriptionJa: '韓国語の基本文法と語彙の習得度をテストします。',
    examType: '基礎檢定', difficulty: 'beginner', totalQuestions: 60,
    passingScore: 70, maxScore: 100, examFormat: '線上考試',
    sections: [
      { name: '한글 읽기', questions: 15, timeLimit: '20分鐘', weight: 25 },
      { name: '어휘', questions: 20, timeLimit: '30分鐘', weight: 35 },
      { name: '문법', questions: 15, timeLimit: '25分鐘', weight: 25 },
      { name: '듣기', questions: 10, timeLimit: '15分鐘', weight: 15 }
    ]
  },

  {
    id: 10, 
    name: '古典文學賞析期末', 
    nameEn: 'Classical Literature Final',
    nameCn: '古典文学赏析期末',
    nameJa: '古典文学鑑賞期末',
    date: '2025-08-15', time: '10:30', fee: 120, status: 'upcoming',
    course: '古典文學賞析', courseId: 2, duration: '150分鐘', participants: 198,
    description: '古典文學作品分析和文學評論寫作。',
    descriptionEn: 'Classical literature analysis and literary criticism writing.',
    descriptionCn: '古典文学作品分析和文学评论写作。',
    descriptionJa: '古典文学作品の分析と文学批評の執筆。',
    examType: '期末考試', difficulty: 'intermediate', totalQuestions: 40,
    passingScore: 70, maxScore: 100, examFormat: '線上考試',
    sections: [
      { name: '作品分析', questions: 15, timeLimit: '60分鐘', weight: 40 },
      { name: '文學史', questions: 10, timeLimit: '30分鐘', weight: 25 },
      { name: '評論寫作', questions: 10, timeLimit: '45分鐘', weight: 25 },
      { name: '比較研究', questions: 5, timeLimit: '15分鐘', weight: 10 }
    ]
  }
];

// 學生數據（保持不變但增加多語言）
export const mockStudents = [
  {
    id: 1, 
    name: '張小明', 
    nameEn: 'Zhang Xiaoming', 
    nameCn: '张小明',
    nameJa: '張小明',
    email: 'zhang.xiaoming@email.com',
    phone: '0912-345-678', avatar: '👨‍💻', birthDate: '2000-03-15',
    enrollDate: '2025-01-15', address: '台北市信義區忠孝東路123號',
    course: 'React 前端開發', courseId: 10, progress: 75, grade: 'A',
    status: 'active', gpa: 3.8, credits: 24, totalHours: 320,
    attendanceRate: 95, assignments: { completed: 18, total: 20 },
    exams: { passed: 8, total: 10 }, currentLevel: 'Intermediate'
  },
  {
    id: 2, 
    name: '李美華', 
    nameEn: 'Li Meihua', 
    nameCn: '李美华',
    nameJa: '李美華',
    email: 'li.meihua@email.com',
    phone: '0923-456-789', avatar: '👩‍🎓', birthDate: '1999-08-22',
    enrollDate: '2025-02-01', address: '新北市板橋區中山路456號',
    course: '英語會話實戰', courseId: 4, progress: 60, grade: 'B+',
    status: 'active', gpa: 3.5, credits: 18, totalHours: 240,
    attendanceRate: 88, assignments: { completed: 15, total: 18 },
    exams: { passed: 6, total: 8 }, currentLevel: 'Upper-Intermediate'
  },
  
  // 新增更多學生數據
  {
    id: 3, 
    name: '王大明', 
    nameEn: 'Wang Daming', 
    nameCn: '王大明',
    nameJa: '王大明',
    email: 'wang.daming@email.com',
    phone: '0934-567-890', avatar: '👨‍🎓', birthDate: '1998-12-05',
    enrollDate: '2025-01-20', address: '高雄市前鎮區民權路789號',
    course: 'Python 機器學習', courseId: 6, progress: 25, grade: 'B',
    status: 'active', gpa: 3.2, credits: 12, totalHours: 160,
    attendanceRate: 78, assignments: { completed: 8, total: 12 },
    exams: { passed: 3, total: 5 }, currentLevel: 'Beginner'
  },
  
  {
    id: 4, 
    name: '陳雅婷', 
    nameEn: 'Chen Yating', 
    nameCn: '陈雅婷',
    nameJa: '陳雅婷',
    email: 'chen.yating@email.com',
    phone: '0945-678-901', avatar: '👩‍💼', birthDate: '2001-04-18',
    enrollDate: '2025-02-10', address: '台中市西屯區台灣大道321號',
    course: '數位行銷策略', courseId: 7, progress: 80, grade: 'A-',
    status: 'active', gpa: 3.7, credits: 20, totalHours: 280,
    attendanceRate: 92, assignments: { completed: 16, total: 18 },
    exams: { passed: 7, total: 8 }, currentLevel: 'Advanced'
  },
  
  {
    id: 5, 
    name: '林志豪', 
    nameEn: 'Lin Zhihao', 
    nameCn: '林志豪',
    nameJa: '林志豪',
    email: 'lin.zhihao@email.com',
    phone: '0956-789-012', avatar: '👨‍💻', birthDate: '1999-09-30',
    enrollDate: '2025-01-25', address: '桃園市中壢區中正路654號',
    course: 'UI/UX 設計實戰', courseId: 8, progress: 45, grade: 'B+',
    status: 'active', gpa: 3.4, credits: 15, totalHours: 200,
    attendanceRate: 85, assignments: { completed: 12, total: 15 },
    exams: { passed: 5, total: 7 }, currentLevel: 'Intermediate'
  },
  
  {
    id: 6, 
    name: '黃淑芬', 
    nameEn: 'Huang Shufen', 
    nameCn: '黄淑芬',
    nameJa: '黃淑芬',
    email: 'huang.shufen@email.com',
    phone: '0967-890-123', avatar: '👩‍🎓', birthDate: '2000-07-12',
    enrollDate: '2025-02-05', address: '台南市安平區健康路987號',
    course: '日語入門', courseId: 9, progress: 90, grade: 'A',
    status: 'active', gpa: 3.9, credits: 22, totalHours: 300,
    attendanceRate: 98, assignments: { completed: 19, total: 20 },
    exams: { passed: 9, total: 10 }, currentLevel: 'Upper-Intermediate'
  },
  
  {
    id: 7, 
    name: '劉建國', 
    nameEn: 'Liu Jianguo', 
    nameCn: '刘建国',
    nameJa: '劉建国',
    email: 'liu.jianguo@email.com',
    phone: '0978-901-234', avatar: '👨‍🔬', birthDate: '1997-11-25',
    enrollDate: '2025-01-30', address: '新竹市東區光復路135號',
    course: '微積分入門', courseId: 5, progress: 55, grade: 'B',
    status: 'active', gpa: 3.1, credits: 16, totalHours: 220,
    attendanceRate: 82, assignments: { completed: 13, total: 16 },
    exams: { passed: 6, total: 8 }, currentLevel: 'Intermediate'
  },
  
  {
    id: 8, 
    name: '吳佩君', 
    nameEn: 'Wu Peijun', 
    nameCn: '吴佩君',
    nameJa: '吳佩君',
    email: 'wu.peijun@email.com',
    phone: '0989-012-345', avatar: '👩‍🏫', birthDate: '2001-02-14',
    enrollDate: '2025-02-15', address: '嘉義市西區民族路246號',
    course: '韓語基礎', courseId: 10, progress: 35, grade: 'C+',
    status: 'active', gpa: 2.8, credits: 10, totalHours: 140,
    attendanceRate: 75, assignments: { completed: 7, total: 12 },
    exams: { passed: 4, total: 6 }, currentLevel: 'Beginner'
  },
  
  {
    id: 9, 
    name: '張偉強', 
    nameEn: 'Zhang Weiqiang', 
    nameCn: '张伟强',
    nameJa: '張偉強',
    email: 'zhang.weiqiang@email.com',
    phone: '0990-123-456', avatar: '👨‍💼', birthDate: '1998-06-08',
    enrollDate: '2025-01-18', address: '基隆市仁愛區孝二路369號',
    course: '古典文學賞析', courseId: 2, progress: 20, grade: 'C',
    status: 'inactive', gpa: 2.5, credits: 8, totalHours: 100,
    attendanceRate: 65, assignments: { completed: 5, total: 10 },
    exams: { passed: 2, total: 5 }, currentLevel: 'Beginner'
  },
  
  {
    id: 10, 
    name: '蔡雅琪', 
    nameEn: 'Cai Yaqi', 
    nameCn: '蔡雅琪',
    nameJa: '蔡雅琪',
    email: 'cai.yaqi@email.com',
    phone: '0901-234-567', avatar: '👩‍💻', birthDate: '2000-10-22',
    enrollDate: '2025-02-08', address: '宜蘭縣羅東鎮中正路147號',
    course: '英語會話實戰', courseId: 4, progress: 70, grade: 'A-',
    status: 'active', gpa: 3.6, credits: 18, totalHours: 250,
    attendanceRate: 90, assignments: { completed: 14, total: 16 },
    exams: { passed: 6, total: 7 }, currentLevel: 'Upper-Intermediate'
  },
  
  {
    id: 11, 
    name: '謝明達', 
    nameEn: 'Xie Mingda', 
    nameCn: '谢明达',
    nameJa: '謝明達',
    email: 'xie.mingda@email.com',
    phone: '0912-345-678', avatar: '👨‍🎨', birthDate: '1999-03-17',
    enrollDate: '2025-01-22', address: '花蓮縣花蓮市中華路258號',
    course: 'UI/UX 設計實戰', courseId: 8, progress: 65, grade: 'B+',
    status: 'active', gpa: 3.3, credits: 17, totalHours: 230,
    attendanceRate: 87, assignments: { completed: 13, total: 15 },
    exams: { passed: 5, total: 6 }, currentLevel: 'Intermediate'
  },
  
  {
    id: 12, 
    name: '林雅慧', 
    nameEn: 'Lin Yahui', 
    nameCn: '林雅慧',
    nameJa: '林雅慧',
    email: 'lin.yahui@email.com',
    phone: '0923-456-789', avatar: '👩‍🔬', birthDate: '2001-08-03',
    enrollDate: '2025-02-12', address: '屏東縣屏東市自由路741號',
    course: 'Python 機器學習', courseId: 6, progress: 40, grade: 'B',
    status: 'active', gpa: 3.0, credits: 14, totalHours: 180,
    attendanceRate: 80, assignments: { completed: 10, total: 14 },
    exams: { passed: 4, total: 6 }, currentLevel: 'Intermediate'
  }
];

// 交易數據（保持不變但增加多語言）
export const mockTransactions = [
  {
    id: 1, date: '2025-06-20', time: '14:30:25', type: '課程購買',
    item: 'React 前端開發', itemId: 10, amount: 799, originalAmount: 999,
    discount: 200, discountType: '早鳥優惠', status: 'completed',
    method: '信用卡', methodDetails: '****-****-****-1234'
  },
  {
    id: 2, date: '2025-06-18', time: '09:15:42', type: '考試報名',
    item: '雅思模擬考試', itemId: 2, amount: 200, originalAmount: 200,
    discount: 0, discountType: null, status: 'completed',
    method: 'PayPal', methodDetails: 'user@paypal.com'
  },
  
  // 新增更多交易數據
  {
    id: 3, date: '2025-06-15', time: '16:45:12', type: '課程購買',
    item: '英語會話實戰', itemId: 4, amount: 599, originalAmount: 799,
    discount: 200, discountType: '學生優惠', status: 'completed',
    method: '銀行轉帳', methodDetails: '中國信託-****-1234'
  },
  
  {
    id: 4, date: '2025-06-12', time: '11:22:35', type: '課程購買',
    item: '微積分入門', itemId: 5, amount: 499, originalAmount: 699,
    discount: 200, discountType: '限時優惠', status: 'completed',
    method: '信用卡', methodDetails: '****-****-****-5678'
  },
  
  {
    id: 5, date: '2025-06-10', time: '13:15:48', type: '考試報名',
    item: 'React 認證考試', itemId: 2, amount: 200, originalAmount: 200,
    discount: 0, discountType: null, status: 'completed',
    method: 'PayPal', methodDetails: 'student@paypal.com'
  },
  
  {
    id: 6, date: '2025-06-08', time: '08:30:22', type: '課程購買',
    item: 'Python 機器學習', itemId: 6, amount: 899, originalAmount: 1199,
    discount: 300, discountType: '早鳥優惠', status: 'completed',
    method: '信用卡', methodDetails: '****-****-****-9012'
  },
  
  {
    id: 7, date: '2025-06-05', time: '19:45:33', type: '課程購買',
    item: '數位行銷策略', itemId: 7, amount: 699, originalAmount: 899,
    discount: 200, discountType: '會員優惠', status: 'completed',
    method: '電子錢包', methodDetails: 'LINE Pay'
  },
  
  {
    id: 8, date: '2025-06-03', time: '14:20:15', type: '考試報名',
    item: '英語口語測試', itemId: 3, amount: 180, originalAmount: 180,
    discount: 0, discountType: null, status: 'pending',
    method: '信用卡', methodDetails: '****-****-****-3456'
  },
  
  {
    id: 9, date: '2025-06-01', time: '10:55:41', type: '課程購買',
    item: 'UI/UX 設計實戰', itemId: 8, amount: 799, originalAmount: 999,
    discount: 200, discountType: '新用戶優惠', status: 'completed',
    method: '銀行轉帳', methodDetails: '台灣銀行-****-7890'
  },
  
  {
    id: 10, date: '2025-05-30', time: '17:10:28', type: '課程購買',
    item: '日語入門', itemId: 9, amount: 399, originalAmount: 499,
    discount: 100, discountType: '促銷活動', status: 'completed',
    method: '信用卡', methodDetails: '****-****-****-2468'
  },
  
  {
    id: 11, date: '2025-05-28', time: '12:35:19', type: '考試報名',
    item: '微積分期中考', itemId: 4, amount: 100, originalAmount: 100,
    discount: 0, discountType: null, status: 'completed',
    method: 'PayPal', methodDetails: 'math@student.com'
  },
  
  {
    id: 12, date: '2025-05-25', time: '15:42:07', type: '課程購買',
    item: '韓語基礎', itemId: 10, amount: 449, originalAmount: 599,
    discount: 150, discountType: '學生優惠', status: 'completed',
    method: '電子錢包', methodDetails: '街口支付'
  },
  
  {
    id: 13, date: '2025-05-22', time: '09:18:54', type: '考試報名',
    item: 'Python 機器學習專案', itemId: 5, amount: 250, originalAmount: 250,
    discount: 0, discountType: null, status: 'upcoming',
    method: '信用卡', methodDetails: '****-****-****-1357'
  },
  
  {
    id: 14, date: '2025-05-20', time: '20:25:36', type: '課程購買',
    item: '古典文學賞析', itemId: 2, amount: 399, originalAmount: 499,
    discount: 100, discountType: '限時優惠', status: 'completed',
    method: '銀行轉帳', methodDetails: '第一銀行-****-4681'
  },
  
  {
    id: 15, date: '2025-05-18', time: '11:50:42', type: '考試報名',
    item: '數位行銷策略案例', itemId: 6, amount: 150, originalAmount: 150,
    discount: 0, discountType: null, status: 'registration',
    method: '信用卡', methodDetails: '****-****-****-9753'
  }
]; 